/* eslint-disable comma-dangle */
/* eslint-disable no-unused-expressions */
/* eslint-disable indent */
/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
/* eslint-disable radix */
/* eslint-disable prefer-template */
/* eslint-disable eqeqeq */
/* eslint-disable prefer-const */
/* eslint-disable semi */
/* eslint-disable arrow-parens */
const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const ScratchBlocksConstants = require('../../engine/scratch-blocks-constants');
const formatMessage = require('format-message');
const blockIconURI = require('./handpy-logo.svg');
const menuIconURI = require('./handpy-menu.svg');
const miniIconURI = require('./handpy-menu.svg');
const Timer = require('../../util/timer');
const Cast = require('../../util/cast');
const MathUtil = require('../../util/math-util');

const toNumber = (num) => {
    if (typeof num == 'number') {
        return isNaN(num) ? 0 : num;
    }
    let number_num = Number(num);
    return isNaN(number_num) ? 0 : number_num;
}
const toFixed = (num, len) => {

    if (len) {
        len = parseInt(len)
    } else {
        len = 0
    }

    if (len <= 0) {
        num = Math.round(num)
    } else {
        num = Math.round(num * Math.pow(10, len)) / Math.pow(10, len)
        num = Number(num).toFixed(len)
    }
    return num
}
const toUnicode = (str) => {
    if (str == '') {
        return ''
    }
    let t = '';
    for (let i = 0; i < str.length; i++){
        if (str.charCodeAt(i) < 256) {
            t += str[i]
        } else {
            t += '\\u' + parseInt(str[i].charCodeAt(0), 10).toString(16)
        }
    }
    return t;
}
const buff2str = (ab) => String.fromCharCode.apply(null, new Uint8Array(ab))

const to16 = (str) => {
    // console.log(str)
    let result10 = 0
    for (let index = 0; index < str.length; index++) {
        // str
        if (str.charAt(index) == 1) {
            result10 += Math.pow(10, index)
        }
    }
    let result2 = parseInt(result10, 2)
    let result16 = result2.toString(16)
    if (result16.length == 1) {
        result16 = '0' + result16
    }
    let result = '0x' + result16
    // console.log(result)
    return result
}
const to2 = (str) => {
    const strArray = []
    strArray[0] = '0x' + str.substring(14, 16)
    strArray[1] = '0x' + str.substring(12, 14)
    strArray[2] = '0x' + str.substring(10, 12)
    strArray[3] = '0x' + str.substring(8, 10)
    strArray[4] = '0x' + str.substring(6, 8)
    strArray[5] = '0x' + str.substring(4, 6)
    strArray[6] = '0x' + str.substring(2, 4)
    strArray[7] = '0x' + str.substring(0, 2)
    let result = ''
    for (let index = 0; index < strArray.length; index++) {
        let element = strArray[index];
        let result10 = parseInt(element)
        let result2 = (result10).toString(2)
        if (result2.length < 8) {
            let zero = '00000000'
            result2 = zero.substring(0, (8 - result2.length)) + result2
        }
        result += result2
    }
    //console.log('result----', result)
    return result
}

const notes = [
    ['C0', '4'],
    ['C0', '5'],
    ['C0', '5'],
    ['C0', '5'],
    ['C0', '6'],
    ['C0', '6'],
    ['C0', '6'],
    ['C0', '7'],
    ['C0', '7'],
    ['C0', '7'],
    ['C0', '8'],
    ['C0', '8'],
    ['C0', '9'],
    ['C0', '9'],
    ['C0', '10'],
    ['C0', '10'],
    ['C0', '11'],
    ['C0', '11'],
    ['C0', '12'],
    ['C0', '13'],
    ['C0', '13'],
    ['C0', '14'],
    ['C0', '15'],
    ['C0', '16'],
    ['C0', '17'],
    ['C#0', '18'],
    ['D0', '19'],
    ['D#0', '20'],
    ['E0', '21'],
    ['F0', '22'],
    ['F#0', '24'],
    ['G0', '25'],
    ['G#0', '26'],
    ['A0', '28'],
    ['A#0', '30'],
    ['B0', '31'],
    ['C1', '33'],
    ['C#1', '35'],
    ['D1', '37'],
    ['D#1', '39'],
    ['E1', '42'],
    ['F1', '44'],
    ['F#1', '47'],
    ['G1', '49'],
    ['G#1', '52'],
    ['A1', '55'],
    ['A#1', '59'],
    ['B1', '62'],
    ['C2', '66'],
    ['C#2', '70'],
    ['D2', '74'],
    ['D#2', '78'],
    ['E2', '84'],
    ['F2', '88'],
    ['F#2', '93'],
    ['G2', '98'],
    ['G#2', '104'],
    ['A2', '110'],
    ['A#2', '117'],
    ['B2', '124'],
    ['C3', '131'],
    ['C#3', '139'],
    ['D3', '147'],
    ['D#3', '156'],
    ['E3', '165'],
    ['F3', '175'],
    ['F#3', '185'],
    ['G3', '196'],
    ['G#3', '208'],
    ['A3', '220'],
    ['A#3', '233'],
    ['B3', '247'],
    ['C4', '262'],
    ['C#4', '277'],
    ['D4', '294'],
    ['D#4', '311'],
    ['E4', '330'],
    ['F4', '349'],
    ['F#4', '370'],
    ['G4', '392'],
    ['G#4', '415'],
    ['A4', '440'],
    ['A#4', '466'],
    ['B4', '494'],
    ['C5', '523'],
    ['C#5', '554'],
    ['D5', '587'],
    ['D#5', '622'],
    ['E5', '659'],
    ['F5', '698'],
    ['F#5', '740'],
    ['G5', '784'],
    ['G#5', '831'],
    ['A5', '880'],
    ['A#5', '932'],
    ['B5', '988'],
    ['C6', '1046'],
    ['C#6', '1108'],
    ['D6', '1174'],
    ['D#6', '1244'],
    ['E6', '1318'],
    ['F6', '1396'],
    ['F#6', '1480'],
    ['G6', '1568'],
    ['G#6', '1662'],
    ['A6', '1760'],
    ['A#6', '1864'],
    ['B6', '1976'],
    ['C7', '2092'],
    ['C#7', '2216'],
    ['D7', '2348'],
    ['D#7', '2488'],
    ['E7', '2636'],
    ['F7', '2792'],
    ['F#7', '2960'],
    ['G7', '3136'],
    ['G#7', '3324'],
    ['A7', '3520'],
    ['A#7', '3728'],
    ['B7', '3952'],
    ['C8', '4184'],
    ['C#8', '4432'],
    ['D8', '4696'],
    ['D#8', '4976'],
    ['E8', '5272'],
    ['F8', '5584'],
    ['F#8', '5920'],
    ['G8', '6272'],
    ['G#8', '6648'],
    ['A8', '7040'],
    ['A#8', '7456']
]
const fnDelay = (num = 300) => {
    let triggerTime = new Date().getTime()
    let index = 0
    while (new Date().getTime() - triggerTime <= num) {
        // ...
        // console.log(index)
        index++
    }
    return true
}
let runcodeTimes = 1;

let assetData = {};
try {
    assetData = require('./manifest');
} catch (e) {
    // Non-webpack environment, don't worry about assets.
}

class aixiongBlocks {
    constructor (runtime) {
        /**
         * The runtime instantiating this block package.
         * @type {Runtime}
         */
        let _this = this
        this.runtime = runtime;
        // console.log('this.runtime --> ', runtime)
        
        if (this.runtime.ioDevices) {
            this.ioDevices = this.runtime.ioDevices
            this.Aixiong = this.ioDevices.Aixiong
            this.runMode = this.Aixiong.runMode
            // this.socket = this.Aixiong.socket
            this.adaptor = this.Aixiong.adaptor
            this.guiTovm = this.Aixiong.guiTovm

            this.handpyVMData = this.Aixiong.handpyVMData
            this.handpyMobileMsg = this.Aixiong.handpyMobileMsg

            this.Aixiong.fnCallback = [] // 确保硬件保留一个监听
            this.Aixiong.fnCallback.push(() => {
                // console.log('_this.Aixiong.handpyVMData, ',  _this.Aixiong.handpyVMData)
                if (_this.handpyVMData.timestamp != _this.Aixiong.handpyVMData.timestamp){
                    // code
                    _this.handpyVMData = _this.Aixiong.handpyVMData
                    _this.sensors.buttonA = _this.handpyVMData.data.A == 'down' ? 1 : 0
                    _this.sensors.buttonB = _this.handpyVMData.data.B == 'down' ? 1 : 0
                    _this.sensors.touchP = _this.handpyVMData.data.P == 'down' ? 1 : 0
                    _this.sensors.touchY = _this.handpyVMData.data.Y == 'down' ? 1 : 0
                    _this.sensors.touchT = _this.handpyVMData.data.T == 'down' ? 1 : 0
                    _this.sensors.touchH = _this.handpyVMData.data.H == 'down' ? 1 : 0
                    _this.sensors.touchO = _this.handpyVMData.data.O == 'down' ? 1 : 0
                    _this.sensors.touchN = _this.handpyVMData.data.N == 'down' ? 1 : 0

                }
                if (_this.handpyMobileMsg.timestamp != _this.Aixiong.handpyMobileMsg.timestamp){
                    _this.handpyMobileMsg = _this.Aixiong.handpyMobileMsg
                    _this.ble.msg = _this.handpyMobileMsg.data
                }
            })
            this.running = false
            console.log('this.ioDevices --> ', this.ioDevices)
        }

        // 智能开发板 start
        this.sensors = {
            buttonA: 0,
            buttonB: 0,
            touchP: 0,
            touchY: 0,
            touchT: 0,
            touchH: 0,
            touchO: 0,
            touchN: 0,
            light: 0,
            sound: 0,
            ext: 0,
            aX: 0,
            aY: 0,
            aZ: 0,
            pinDigital: [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            pinAnalog: [0, 0, 0, 0],
            gesture: 0,
            msgRadio: '',
            timerRadio: null,
            monitor: [],
            timerMonitor: null
        }

        this.ticks = 4 / 4
        this.bpmTime = 125
        this.musicOctave = 0
        this.musicOutput = 6
        this.brightness = 9
        this.hasData = false

        this.lockConnect = false
        this.gestures = {
            moving: false,
            shake: {active: false, timeout: false},
            jump: {active: false, timeout: false}
        }
        
        this.wifi = {
            ssid: 'my_wifi',
            password: '12345678',
            status: '未连接',
            ip: '192.168.1.100'
        }
        this.seniverseData = {
            lastresult_search: '',
            lastresult: '',
            lastresultDate: new Date().getTime(),
            location: '',
            now: {
                text: '',
                temperature: '',
                pressure: '',
                humidity: '',
                wind_direction: '',
                wind_scale: ''
            }
        }
        this.seniversePreData = {
            lastresult_search: '',
            lastresult: '',
            lastresultDate: new Date().getTime(),
            location: '',
            daily: {
                text_day: '',
                high: '',
                text_night: '',
                low: ''
            }
        }

        this.siot = {
            ID: 'ABC',
            SERVER: '192.168.1.154',
            USER: 'siot',
            PASSWORD: '12345678',
            status: 'SIot未连接',
            topic_1: '',
            topic_2: '',
            topic_3: '',
        }

        // this.sensors.sound;
        this._timer = new Timer();
        this._cachedLoudness = -1;
        this._cachedLoudnessTimestamp = 0;
        this._cachedLoudnessErrCount = 0;
        this._cachedLoudness0Count = 0;

        this.handpyModal = false
        this.handpyWebsiteModal = false
        this.handpyMobileBtn = false
        this.handpyMobileMsg = false

        this.ble = {
            status: 'BLE UART 已连接',
            msg: ''
        }

        // 音频播放
        this._concurrencyCounter = 0;
        this._musicPlayers = [];
        this._instrumentPlayerArrays = [];
        this._instrumentPlayerNoteArrays = [];

        this._loadAllSounds();

        // I2C射频卡
        this.digitalWallet = {
            status: '未开启',
            ble: false,
            balance: 0
        }
        // 智能开发板 end

    }

    /**
     * The key to load & store a target's test-related state.
     * @type {string}
     */
    static get STATE_KEY () {
        return 'Scratch.handpy';
    }


    /**
     * @returns {object} metadata for this extension and its blocks.
     */
    getInfo () {
        return {
            // 详细介绍：https://github.com/LLK/scratch-vm/blob/develop/docs/extensions.md
            // Required: the machine-readable name of this extension.
            // Will be used as the extension's namespace.
            id: 'handpyVirtual',
            name: 'AI套件',
            menuIconURI: menuIconURI,
            blockIconURI: blockIconURI,
            color1: '#017ab3',
            color2: '#016ea1',
            color3: '#01699a',
            // docsURI: 'https://....', // 文档地址
            showStatusButton: false, // 插件右上角的硬件连接状态显示按钮
            customFieldTypes: {
                messageMQTT: {
                    output: 'Number',
                    outputShape: ScratchBlocksConstants.OUTPUT_SHAPE_ROUND,
                    // implementation
                }
            },
            blocks: [
                {
                    opcode: 'main',
                    runMode: 1, // 0,
                    text: '智能开发板主程序',
                    blockType: BlockType.HAT,
                }, {
                    opcode: 'print',
                    runMode: 1, // 0,
                    blockType: BlockType.COMMAND,
                    text: '打印[TEXT]',
                    arguments: {
                        TEXT: {
                            type: ArgumentType.STRING,
                            defaultValue: 'Hello, world'
                        },
                    },
                },

                '传感器',
                // {
                //     opcode: 'getLightValue',
                //     runMode: 0, // 1,
                //     text: '光线传感器值',
                //     blockType: BlockType.REPORTER,
                // }, 
                {
                    opcode: 'getSoundValue',
                    runMode: 1, // 1,
                    text: '声音传感器值',
                    blockType: BlockType.REPORTER,
                }, 
                // {
                //     opcode: 'getExtValue',
                //     runMode: 0, // 1,
                //     text: '扩展传感器值',
                //     blockType: BlockType.REPORTER,
                // }, {
                //     opcode: 'getAxValue',
                //     runMode: 0, // 1,
                //     text: 'X轴 加速度值',
                //     blockType: BlockType.REPORTER,
                // }, {
                //     opcode: 'getAyValue',
                //     runMode: 0, // 1,
                //     text: 'Y轴 加速度值',
                //     blockType: BlockType.REPORTER,
                // }, {
                //     opcode: 'getAzValue',
                //     runMode: 0, // 1,
                //     text: 'Z轴 加速度值',
                //     blockType: BlockType.REPORTER,
                // }, {
                //     opcode: 'getAgValue',
                //     runMode: 0, // 1,
                //     text: '重力加速度值',
                //     blockType: BlockType.REPORTER,
                // }, 
                {
                    opcode: 'isButtonPressed',
                    text: '按键[BTN]被按下？',
                    blockType: BlockType.BOOLEAN,
                    arguments: {
                        BTN: {
                            type: ArgumentType.STRING,
                            menu: 'button_touchkey',
                            defaultValue: 'A',
                        },
                    },
                }, {
                    opcode: 'getTouchKeyValue',
                    runMode: 1, // 0,
                    text: '[TOUCH]触摸键值',
                    blockType: BlockType.REPORTER,
                    arguments: {
                        TOUCH: {
                            type: ArgumentType.STRING,
                            menu: 'touchkeys',
                            defaultValue: 'P',
                        },
                    },
                }, 
                // {
                //     opcode: 'isGesture',
                //     text: '[GESTURE]?',
                //     blockType: BlockType.BOOLEAN,
                //     arguments: {
                //         GESTURE: {
                //             type: ArgumentType.STRING,
                //             menu: 'gestures',
                //             defaultValue: 'shaken',
                //         },
                //     },
                // }, 
                // {
                //     opcode: 'getTiltAngle2',
                //     runMode: 0, // 1,
                //     text: '[TILTED]角度',
                //     blockType: BlockType.REPORTER,
                //     arguments: {
                //         TILTED: {
                //             type: ArgumentType.STRING,
                //             menu: 'tilted',
                //             defaultValue: 'tilted_right',
                //         },
                //     },
                // }, 
                // {
                //     opcode: 'getSensorValue',
                //     runMode: 1, // 0,
                //     text: '[SENSOR]值',
                //     blockType: BlockType.REPORTER,
                //     arguments: {
                //         SENSOR: {
                //             type: ArgumentType.STRING,
                //             menu: 'sensors',
                //             defaultValue: 'sound',
                //         },
                //     },
                // }, 
                // {
                //     opcode: 'getAccelerationValue',
                //     runMode: 1, // 0,
                //     text: '[AXIS]加速度值',
                //     blockType: BlockType.REPORTER,
                //     arguments: {
                //         AXIS: {
                //             type: ArgumentType.STRING,
                //             menu: 'axes_g',
                //             defaultValue: 'X',
                //         },
                //     },
                // }, {
                //     opcode: 'setAccelerationRange',
                //     runMode: 1, // 0,
                //     text: '设置加速度范围为[RANGE]',
                //     blockType: BlockType.COMMAND,
                //     arguments: {
                //         RANGE: {
                //             type: ArgumentType.STRING,
                //             menu: 'acceleration_range',
                //             defaultValue: '2G',
                //         },
                //     },
                // }, {
                //     opcode: 'getTiltAngle',
                //     runMode: 1, // 0,
                //     text: '[AXIS]倾斜角',
                //     blockType: BlockType.REPORTER,
                //     arguments: {
                //         AXIS: {
                //             type: ArgumentType.STRING,
                //             menu: 'axes',
                //             defaultValue: 'X',
                //         },
                //     },
                // }, {
                //     opcode: 'getMagneticHeading',
                //     runMode: 1, // 0,
                //     text: '指南针方向',
                //     blockType: BlockType.REPORTER,
                //     disableMonitor: true,
                // }, {
                //     opcode: 'getMagnetic',
                //     runMode: 1, // 0,
                //     text: '[AXIS]磁感应值',
                //     blockType: BlockType.REPORTER,
                //     arguments: {
                //         AXIS: {
                //             type: ArgumentType.STRING,
                //             menu: 'axes_m',
                //             defaultValue: 'X',
                //         },
                //     },
                // }, {
                //     opcode: 'getRunningTime',
                //     runMode: 1, // 0,
                //     text: '运行时间[TYPE]',
                //     blockType: BlockType.REPORTER,
                //     arguments: {
                //         TYPE: {
                //             type: ArgumentType.STRING,
                //             menu: 'second_type',
                //             defaultValue: 'millisecond',
                //         },
                //     },
                // }, {
                //     opcode: 'getTimeDifference',
                //     runMode: 1, // 0,
                //     text: '计算时间差 从[TIME1]到[TIME2]',
                //     blockType: BlockType.REPORTER,
                //     arguments: {
                //         TIME1: {
                //             type: ArgumentType.NUMBER,
                //             defaultValue: ''
                //         },
                //         TIME2: {
                //             type: ArgumentType.NUMBER,
                //             defaultValue: ''
                //         },
                //     },
                // }, {
                //     opcode: 'getLocalTime',
                //     runMode: 1, // 0,
                //     text: '本地时间[TYPE]',
                //     blockType: BlockType.REPORTER,
                //     arguments: {
                //         TYPE: {
                //             type: ArgumentType.STRING,
                //             menu: 'localtime_type',
                //             defaultValue: 'year',
                //         },
                //     },
                // },

                '事件',
                {
                    opcode: 'whenButtonPressed',
                    text: '当[BTN]按钮[ACTION]',
                    blockType: BlockType.HAT,
                    arguments: {
                        BTN: {
                            type: ArgumentType.STRING,
                            menu: 'button_touchkey',
                            defaultValue: 'A'
                        },
                        ACTION: {
                            type: ArgumentType.STRING,
                            menu: 'buttonstate',
                            defaultValue: 'pressed'
                        }
                    }
                }, 
                // {
                //     opcode: 'whenGesture',
                //     text: '当[GESTURE]时',
                //     blockType: BlockType.HAT,
                //     arguments: {
                //         GESTURE: {
                //             type: ArgumentType.STRING,
                //             menu: 'gestures',
                //             defaultValue: 'shaken',
                //         },
                //     },
                // }, {
                //     opcode: 'whenPinAction',
                //     runMode: 1, // 0,
                //     text: '当引脚[PIN]电平[ACTION]',
                //     blockType: BlockType.HAT,
                //     arguments: {
                //         PIN: {
                //             type: ArgumentType.STRING,
                //             menu: 'pins',
                //             defaultValue: '0',
                //         },
                //         ACTION: {
                //             type: ArgumentType.STRING,
                //             menu: 'pinaction',
                //             defaultValue: 'to_high',
                //         },
                //     },
                // },

                // 'RGB LED灯',
                // {
                //     opcode: 'setRGBColor',
                //     blockType: BlockType.COMMAND,
                //     text: 'LED 设置[RGB]灯颜色为[COLOR]',
                //     arguments: {
                //         RGB: {
                //             type: ArgumentType.STRING,
                //             menu: 'rgbs',
                //             defaultValue: '0',
                //         },
                //         COLOR: {type: ArgumentType.COLORRGB},
                //     },
                // }, {
                //     opcode: 'setRGBColorNum',
                //     blockType: BlockType.COMMAND,
                //     text: 'LED 设置[RGB]灯颜色为 R[R]G[G]B[B]',
                //     arguments: {
                //         RGB: {
                //             type: ArgumentType.STRING,
                //             menu: 'rgbs',
                //             defaultValue: '0',
                //         },
                //         R: {
                //             type: ArgumentType.NUMBERRANGE,
                //             defaultValue: 255,
                //         },
                //         G: {
                //             type: ArgumentType.NUMBERRANGE,
                //             defaultValue: 0,
                //         },
                //         B: {
                //             type: ArgumentType.NUMBERRANGE,
                //             defaultValue: 0,
                //         },
                //     },
                // }, {
                //     opcode: 'turnOffRGB',
                //     blockType: BlockType.COMMAND,
                //     text: 'LED 关闭[RGB]灯',
                //     arguments: {
                //         RGB: {
                //             type: ArgumentType.STRING,
                //             menu: 'rgbs',
                //             defaultValue: 'ALL',
                //         },
                //     },
                // }, {
                //     opcode: 'setLedBrightness',
                //     blockType: BlockType.COMMAND,
                //     text: 'LED 设置亮度为[BRIGHTNESS]',
                //     arguments: {
                //         BRIGHTNESS: {
                //             type: ArgumentType.STRING,
                //             menu: 'brightness',
                //             defaultValue: '9',
                //         },
                //     },
                // }, {
                //     opcode: 'getLedBrightness2',
                //     runMode: 0, // 1,
                //     blockType: BlockType.REPORTER,
                //     text: 'LED 亮度',
                    
                // }, {
                //     opcode: 'getLedBrightness',
                //     runMode: 1, // 0,
                //     blockType: BlockType.REPORTER,
                //     text: 'LED 亮度',
                //     disableMonitor: true
                // },

                '音乐',
                {
                    opcode: 'stopMusic',
                    blockType: BlockType.COMMAND,
                    text: '停止播放音乐',
                }, {
                    opcode: 'playTone',
                    text: '持续演奏音符[TONE]',
                    blockType: BlockType.COMMAND,
                    arguments: {
                        TONE: {
                            type: ArgumentType.NOTE,
                            defaultValue: 60,
                        },
                    },
                }, {
                    opcode: 'playToneFor',
                    text: '演奏音符[TONE][DURATION]秒',
                    blockType: BlockType.COMMAND,
                    arguments: {
                        TONE: {
                            type: ArgumentType.NOTE,
                            defaultValue: 60,
                        },
                        DURATION: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0.5,
                        },
                    },
                }, {
                    opcode: 'playNote',
                    text: '演奏音符[TONE][BEAT]拍',
                    blockType: BlockType.COMMAND,
                    arguments: {
                        TONE: {
                            type: ArgumentType.NOTE,
                            defaultValue: 60
                        },
                        BEAT: {
                            type: ArgumentType.NUMBER,
                            menu: 'beats',
                            defaultValue: '4'
                        }
                    }
                }, {
                    opcode: 'playEmptyNote',
                    text: '休止[BEAT]拍',
                    blockType: BlockType.COMMAND,
                    arguments: {
                        BEAT: {
                            type: ArgumentType.NUMBER,
                            menu: 'beats',
                            defaultValue: '4',
                        },
                    },
                }, {
                    opcode: 'setMusicTempo',
                    text: '每一拍等同[TICKS]分音符，每分钟节拍数[BPM]',
                    blockType: BlockType.COMMAND,
                    arguments: {
                        TICKS: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 4,
                        },
                        BPM: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 120,
                        },
                    },
                }, {
                    opcode: 'playMusic',
                    runMode: 1,// 0,
                    text: '播放音乐[MUSIC]',
                    blockType: BlockType.COMMAND,
                    arguments: {
                        MUSIC: {
                            type: ArgumentType.NUMBER,
                            // menu: 'innermusic',
                            menu: 'MUSIC',
                            defaultValue: 0,
                        },
                        // MODE: {
                        //     type: ArgumentType.STRING,
                        //     menu: 'repeatmode',
                        //     defaultValue: '1',
                        // },
                    },
                }, 
                {
                    opcode: 'setMusicOctave',
                    runMode: 0, // 1,
                    text: '设置音阶[OCTAVE]',
                    blockType: BlockType.COMMAND,
                    arguments: {
                        OCTAVE: {
                            type: ArgumentType.NUMBER,
                            menu: 'music_octave',
                            defaultValue: 0,
                        },
                    },
                }, 
                // {
                //     opcode: 'setMusicOutput',
                //     text: '设置音乐输出端口[PORT]',
                //     blockType: BlockType.COMMAND,
                //     arguments: {
                //         PORT: {
                //             type: ArgumentType.STRING,
                //             menu: 'pin_music',
                //             defaultValue: '6',
                //         },
                //     },
                // },

                // '无线广播',
                // {
                //     opcode: 'turnRadioOn',
                //     blockType: BlockType.COMMAND,
                //     text: '开启无线广播 频道[CHANNEL]',
                //     arguments: {
                //         CHANNEL: {
                //             type: ArgumentType.STRING,
                //             menu: 'wifichannel',
                //             defaultValue: '13',
                //         },
                //     },
                // }, {
                //     opcode: 'turnRadioOff',
                //     blockType: BlockType.COMMAND,
                //     text: '关闭无线广播',
                // }, {
                //     opcode: 'sendRadioMessage',
                //     blockType: BlockType.COMMAND,
                //     text: '发送无线广播消息[MESSAGE]',
                //     arguments: {
                //         MESSAGE: {
                //             type: ArgumentType.STRING,
                //             defaultValue: 'msg',
                //         },
                //     },
                // }, {
                //     opcode: 'whenRadioRecvMessage',
                //     runMode: 1, // 0,
                //     text: '当接收到 任意无线广播消息[MESSAGE]',
                //     blockType: BlockType.HAT,
                //     arguments: {
                //         MESSAGE: {
                //             type: ArgumentType.STRING,
                //             defaultValue: 'msg',
                //         },
                //     },
                // }, {
                //     opcode: 'whenRadioRecv',
                //     text: '当接收到 任意无线广播消息时',
                //     blockType: BlockType.HAT,
                // }, {
                //     opcode: 'getRadioMessage',
                //     blockType: BlockType.REPORTER,
                //     text: '收到的无线广播消息',
                //     disableMonitor: false
                // },

                '显示',
                {
                    opcode: 'oledShow',
                    runMode: 1, // 0,
                    blockType: BlockType.COMMAND,
                    text: 'OLED 显示生效',
                }, {
                    opcode: 'oledClear',
                    blockType: BlockType.COMMAND,
                    text: 'OLED 显示[CLEAR]',
                    arguments: {
                        CLEAR: {
                            type: ArgumentType.STRING,
                            menu: 'oledclear',
                            defaultValue: 'clear',
                        },
                    },
                }, {
                    opcode: 'oledDisplayByLine',
                    blockType: BlockType.COMMAND,
                    text: 'OLED 第[LINE]行显示[TEXT]',
                    arguments: {
                        LINE: {
                            type: ArgumentType.STRING,
                            menu: 'oledlines',
                            defaultValue: '1',
                        },
                        TEXT: {
                            type: ArgumentType.STRING,
                            defaultValue: 'Hello, world',
                        },
                    },
                }, {
                    opcode: 'oledClearByLine',
                    blockType: BlockType.COMMAND,
                    text: 'OLED 清除第[LINE]行',
                    arguments: {
                        LINE: {
                            type: ArgumentType.STRING,
                            menu: 'oledlines',
                            defaultValue: '1',
                        },
                    },
                }, 
                // {
                //     opcode: 'oledDisplayText',
                //     blockType: BlockType.COMMAND,
                //     text: 'OLED 在坐标X[X]Y[Y]显示[TEXT]',
                //     arguments: {
                //         TEXT: {
                //             type: ArgumentType.STRING,
                //             defaultValue: 'Hello, world',
                //         },
                //         X: {
                //             type: ArgumentType.NUMBERRANGE127,
                //             defaultValue: 0,
                //         },
                //         Y: {
                //             type: ArgumentType.NUMBERRANGE63,
                //             defaultValue: 0,
                //         },
                //     },
                // }, {
                //     opcode: 'oledDrawPoint',
                //     blockType: BlockType.COMMAND,
                //     text: 'OLED 描点X[X]Y[Y]为[POINTMODE]',
                //     arguments: {
                //         POINTMODE: {
                //             type: ArgumentType.STRING,
                //             menu: 'oledpointmode',
                //             defaultValue: '1',
                //         },
                //         X: {
                //             type: ArgumentType.NUMBERRANGE127,
                //             defaultValue: 0,
                //         },
                //         Y: {
                //             type: ArgumentType.NUMBERRANGE63,
                //             defaultValue: 0,
                //         },
                //     },
                // }, {
                //     opcode: 'oledDrawLine',
                //     blockType: BlockType.COMMAND,
                //     text: 'OLED[DRAWMETHOD]直线 从点 X1[X1]Y1[Y1]到点 X2[X2]Y2[Y2]',
                //     arguments: {
                //         DRAWMETHOD: {
                //             type: ArgumentType.STRING,
                //             menu: 'oleddrawmethod',
                //             defaultValue: '1',
                //         },
                //         X1: {
                //             type: ArgumentType.NUMBERRANGE127,
                //             defaultValue: 0,
                //         },
                //         Y1: {
                //             type: ArgumentType.NUMBERRANGE63,
                //             defaultValue: 0,
                //         },
                //         X2: {
                //             type: ArgumentType.NUMBERRANGE127,
                //             defaultValue: 50,
                //         },
                //         Y2: {
                //             type: ArgumentType.NUMBERRANGE63,
                //             defaultValue: 50,
                //         },
                //     },
                // }, {
                //     opcode: 'oledDrawVHLine',
                //     blockType: BlockType.COMMAND,
                //     text: 'OLED [DRAWMETHOD][DRAWDIRECTION]直线 从点X[X]Y[Y]长度[LEN]',
                //     arguments: {
                //         DRAWMETHOD: {
                //             type: ArgumentType.STRING,
                //             menu: 'oleddrawmethod',
                //             defaultValue: '1',
                //         },
                //         DRAWDIRECTION: {
                //             type: ArgumentType.STRING,
                //             menu: 'oleddrawdirection',
                //             defaultValue: '1',
                //         },
                //         X: {
                //             type: ArgumentType.NUMBERRANGE127,
                //             defaultValue: 10,
                //         },
                //         Y: {
                //             type: ArgumentType.NUMBERRANGE63,
                //             defaultValue: 10,
                //         },
                //         LEN: {
                //             type: ArgumentType.NUMBER,
                //             defaultValue: 20,
                //         },
                //     },
                // }, {
                //     opcode: 'oledProgressBar',
                //     runMode: 1, // 0,
                //     blockType: BlockType.COMMAND,
                //     text: 'OLED [DRAWDIRECTION]进度条 点X[X]Y[Y]宽[W]高[H]百分比[P]%',
                //     arguments: {
                //         DRAWDIRECTION: {
                //             type: ArgumentType.STRING,
                //             menu: 'oleddrawdirection',
                //             defaultValue: '0',
                //         },
                //         X: {
                //             type: ArgumentType.NUMBERRANGE127,
                //             defaultValue: 64,
                //         },
                //         Y: {
                //             type: ArgumentType.NUMBERRANGE63,
                //             defaultValue: 20,
                //         },
                //         W: {
                //             type: ArgumentType.NUMBER,
                //             defaultValue: 6,
                //         },
                //         H: {
                //             type: ArgumentType.NUMBER,
                //             defaultValue: 30,
                //         },
                //         P: {
                //             type: ArgumentType.NUMBER,
                //             defaultValue: 20,
                //         },
                //     },
                // }, {
                //     opcode: 'oledDrawRectangle',
                //     blockType: BlockType.COMMAND,
                //     text: 'OLED [DRAWMETHOD][FILLMODE]矩形 点 X[X]Y[Y]宽[W]高[H]',
                //     arguments: {
                //         DRAWMETHOD: {
                //             type: ArgumentType.STRING,
                //             menu: 'oleddrawmethod',
                //             defaultValue: '1',
                //         },
                //         FILLMODE: {
                //             type: ArgumentType.STRING,
                //             menu: 'oledfillmode',
                //             defaultValue: '_',
                //         },
                //         X: {
                //             type: ArgumentType.NUMBERRANGE127,
                //             defaultValue: 20,
                //         },
                //         Y: {
                //             type: ArgumentType.NUMBERRANGE63,
                //             defaultValue: 20,
                //         },
                //         W: {
                //             type: ArgumentType.NUMBER,
                //             defaultValue: 20,
                //         },
                //         H: {
                //             type: ArgumentType.NUMBER,
                //             defaultValue: 15,
                //         },
                //     },
                // }, {
                //     opcode: 'oledDrawCircle',
                //     blockType: BlockType.COMMAND,
                //     text: 'OLED [DRAWMETHOD][FILLMODE]圆 点 X[X]Y[Y]半径[R]',
                //     arguments: {
                //         DRAWMETHOD: {
                //             type: ArgumentType.STRING,
                //             menu: 'oleddrawmethod',
                //             defaultValue: '1',
                //         },
                //         FILLMODE: {
                //             type: ArgumentType.STRING,
                //             menu: 'oledfillmode',
                //             defaultValue: '_',
                //         },
                //         X: {
                //             type: ArgumentType.NUMBERRANGE127,
                //             defaultValue: 64,
                //         },
                //         Y: {
                //             type: ArgumentType.NUMBERRANGE63,
                //             defaultValue: 32,
                //         },
                //         R: {
                //             type: ArgumentType.NUMBER,
                //             defaultValue: 15,
                //         },
                //     },
                // }, {
                //     opcode: 'oledDrawTriangle',
                //     blockType: BlockType.COMMAND,
                //     text: 'OLED[DRAWMETHOD][FILLMODE]三角形 点1 X1[X1]Y1[Y1] 点2 X2[X2]Y2[Y2]点3 X3[X3]Y3[Y3]',
                //     arguments: {
                //         DRAWMETHOD: {
                //             type: ArgumentType.STRING,
                //             menu: 'oleddrawmethod',
                //             defaultValue: '1',
                //         },
                //         FILLMODE: {
                //             type: ArgumentType.STRING,
                //             menu: 'oledfillmode',
                //             defaultValue: '_',
                //         },
                //         X1: {
                //             type: ArgumentType.NUMBERRANGE127,
                //             defaultValue: 60,
                //         },
                //         Y1: {
                //             type: ArgumentType.NUMBERRANGE63,
                //             defaultValue: 20,
                //         },
                //         X2: {
                //             type: ArgumentType.NUMBERRANGE127,
                //             defaultValue: 20,
                //         },
                //         Y2: {
                //             type: ArgumentType.NUMBERRANGE63,
                //             defaultValue: 20,
                //         },
                //         X3: {
                //             type: ArgumentType.NUMBERRANGE127,
                //             defaultValue: 40,
                //         },
                //         Y3: {
                //             type: ArgumentType.NUMBERRANGE63,
                //             defaultValue: 40,
                //         },
                //     },
                // }, {
                //     opcode: 'oledDisplayImage',
                //     blockType: BlockType.COMMAND,
                //     text: 'OLED 显示内置图像[IMAGE]在 X[X]Y[Y]',
                //     arguments: {
                //         IMAGE: {
                //             type: ArgumentType.STRING,
                //             menu: 'innerimage',
                //             defaultValue: "'face/Expressions/Heart large.pbm'",
                //         },
                //         X: {
                //             type: ArgumentType.NUMBERRANGE127,
                //             defaultValue: 20,
                //         },
                //         Y: {
                //             type: ArgumentType.NUMBERRANGE63,
                //             defaultValue: 0,
                //         },
                //     },
                // }, {
                //     opcode: 'oledDisplayLocalImage',
                //     blockType: BlockType.COMMAND,
                //     text: 'OLED 显示自选图像[IMAGE]在 X[X]Y[Y]',
                //     arguments: {
                //         IMAGE: {
                //             type: ArgumentType.IMAGESELECTOR
                //         },
                //         X: {
                //             type: ArgumentType.NUMBERRANGE127,
                //             defaultValue: 40,
                //         },
                //         Y: {
                //             type: ArgumentType.NUMBERRANGE63,
                //             defaultValue: 8,
                //         },
                //     },
                // },

                '引脚',
                // {
                //     opcode: 'getPinDigitalValue',
                //     text: 'PIN[PIN]数字值',
                //     blockType: BlockType.BOOLEAN,
                //     arguments: {
                //         PIN: {
                //             type: ArgumentType.STRING,
                //             menu: 'pins',
                //             defaultValue: '0',
                //         },
                //     },
                // }, {
                //     opcode: 'setPinDigitalValue',
                //     text: 'PIN 设置[PIN]数字值为[STATE]',
                //     blockType: BlockType.COMMAND,
                //     arguments: {
                //         PIN: {
                //             type: ArgumentType.STRING,
                //             menu: 'pin_output',
                //             defaultValue: '0',
                //         },
                //         STATE: {
                //             type: ArgumentType.STRING,
                //             menu: 'pin_digital_state',
                //             defaultValue: '1',
                //         },
                //     },
                // }, 
                {
                    opcode: 'getPinAnalogValue',
                    text: 'PIN[PIN]模拟值',
                    blockType: BlockType.REPORTER,
                    arguments: {
                        PIN: {
                            type: ArgumentType.STRING,
                            menu: 'pin_get_analog',
                            defaultValue: '0',
                        },
                    },
                }, 
                // {
                //     opcode: 'setPinAnalogValue',
                //     text: 'PIN 设置[PIN]模拟值 (PWM) 为[VALUE]',
                //     blockType: BlockType.COMMAND,
                //     arguments: {
                //         PIN: {
                //             type: ArgumentType.STRING,
                //             menu: 'pin_output',
                //             defaultValue: '0',
                //         },
                //         VALUE: {
                //             type: ArgumentType.NUMBERRANGE1023,
                //             defaultValue: 1023,
                //         },
                //     },
                // }, 
                {
                    opcode: 'setPinServoAngle',
                    text: 'PIN 设置舵机[PIN]角度为[ANGLE]',
                    blockType: BlockType.COMMAND,
                    arguments: {
                        PIN: {
                            type: ArgumentType.STRING,
                            // menu: 'pin_output',
                            menu: 'pin_get_analog', // 为了获取舵机的值,使用模拟针脚
                            defaultValue: '0',
                        },
                        ANGLE: {
                            type: ArgumentType.ANGLE,
                            defaultValue: 60,
                        },
                    },
                },
                
                // 'Wi-Fi',
                {
                    blockType: BlockType.STRING,
                    runMode: 1, // 0,
                    text: 'Wi-Fi'
                }, {
                    opcode: 'connectWifi',
                    runMode: 1, // 0,
                    blockType: BlockType.COMMAND,
                    text: 'Wi-Fi 连接 SSID[SSID]密码[PASSWORD]',
                    arguments: {
                        SSID: {
                            type: ArgumentType.STRING,
                            defaultValue: 'my_wifi',
                        },
                        PASSWORD: {
                            type: ArgumentType.STRING,
                            defaultValue: '12345678',
                        },
                    },
                }, {
                    opcode: 'hasConnectedWifi',
                    runMode: 1, // 0,
                    blockType: BlockType.BOOLEAN,
                    text: 'Wi-Fi 已连接',
                }, {
                    opcode: 'getWifiInfo',
                    runMode: 1, // 0,
                    blockType: BlockType.REPORTER,
                    text: 'Wi-Fi 配置信息[WIFI_INFO]',
                    arguments: {
                        WIFI_INFO: {
                            type: ArgumentType.NUMBER,
                            menu: 'wifiinfo',
                            defaultValue: '0'
                        },
                    },
                    disableMonitor: true
                }, {
                    opcode: 'disconnectWifi',
                    runMode: 1, // 0,
                    blockType: BlockType.COMMAND,
                    text: 'Wi-Fi 断开连接',
                }, 
                // {
                //     opcode: 'enableAPMode',
                //     runMode: 1, //0,
                //     blockType: BlockType.COMMAND,
                //     text: 'Wi-Fi 开启AP模式 SSID[SSID]信道[CHANNEL]',
                //     arguments: {
                //         SSID: {
                //             type: ArgumentType.STRING,
                //             defaultValue: 'mPython',
                //         },
                //         CHANNEL: {
                //             type: ArgumentType.STRING,
                //             menu: 'wifichannel',
                //             defaultValue: '11',
                //         },
                //     },
                // }, {
                //     opcode: 'disableAPMode',
                //     runMode: 1, // 0,
                //     blockType: BlockType.COMMAND,
                //     text: 'Wi-Fi 关闭AP模式'
                // }, {
                //     opcode: 'syncNetTime',
                //     runMode: 1, // 0,
                //     blockType: BlockType.COMMAND,
                //     text: 'Wi-Fi 同步网络时间 时区[TIMEZONE] 授时服务器[SERVER]',
                //     arguments: {
                //         TIMEZONE: {
                //             type: ArgumentType.STRING,
                //             menu: 'timezone',
                //             defaultValue: '8',
                //         },
                //         SERVER: {
                //             type: ArgumentType.STRING,
                //             menu: 'timeserver',
                //             defaultValue:
                //                 'time.windows.com',
                //         },
                //     },
                // },

                // 语音 Speech
                // {
                //     blockType: BlockType.STRING,
                //     runMode: 1, // 0,
                //     text: '语音'
                // }, {
                //     opcode: 'speechRecognition',
                //     runMode: 1,// 0,
                //     blockType: BlockType.COMMAND,
                //     text: '语音识别 录音[DURATION]秒后识别一次',
                //     arguments: {
                //         DURATION: {
                //             type: ArgumentType.NUMBER,
                //             defaultValue: 2,
                //         },
                //     },
                //     disableMonitor: true
                // }, {
                //     opcode: 'getSpeechText',
                //     runMode: 1, // 0,
                //     blockType: BlockType.REPORTER,
                //     text: '语音识别 获取识别结果',
                //     disableMonitor: true
                // }, {
                //     opcode: 'isSpeechContains',
                //     runMode: 1, // 0,
                //     blockType: BlockType.BOOLEAN,
                //     text: '语音识别 结果中包含[MESSAGE]',
                //     arguments: {
                //         MESSAGE: {
                //             type: ArgumentType.STRING,
                //             defaultValue: 'hello',
                //         },
                //     },
                // },

                // 多线程 Thread
                // {
                //     blockType: BlockType.STRING,
                //     runMode: 1, // 0,
                //     text: '多线程'
                // }, {
                //     opcode: 'defineThread',
                //     runMode: 1, // 0,
                //     text: '定义线程[THREAD]',
                //     blockType: BlockType.HAT,
                //     arguments: {
                //         THREAD: {
                //             type: ArgumentType.STRING,
                //             menu: 'thread',
                //             defaultValue: '1',
                //         },
                //     },
                // }, {
                //     opcode: 'runThread',
                //     runMode: 1, // 0,
                //     text: '运行线程[THREAD]',
                //     blockType: BlockType.COMMAND,
                //     arguments: {
                //         THREAD: {
                //             type: ArgumentType.STRING,
                //             menu: 'thread',
                //             defaultValue: '1',
                //         },
                //     },
                // },

                // 扩展 extension
                // {
                //     blockType: BlockType.STRING,
                //     runMode: 1, // 0,
                //     text: '扩展'
                // }, {
                //     opcode: 'motorRun',
                //     runMode: 1, // 0,
                //     text: '直流电机[PIN][DIRECTION]速度[SPEED]',
                //     blockType: BlockType.COMMAND,
                //     arguments: {
                //         PIN: {
                //             type: ArgumentType.STRING,
                //             menu: 'mpin',
                //             defaultValue: 'MOTOR_1',
                //         },
                //         DIRECTION: {
                //             type: ArgumentType.STRING,
                //             menu: 'mdirection',
                //             defaultValue: '1',
                //         },
                //         SPEED: {
                //             type: ArgumentType.NUMBER,
                //             defaultValue: 100,
                //         },
                //     },
                // }, {
                //     opcode: 'motorStop',
                //     runMode: 1, // 0,
                //     text: '关闭直流电机[PIN]',
                //     blockType: BlockType.COMMAND,
                //     arguments: {
                //         PIN: {
                //             type: ArgumentType.STRING,
                //             menu: 'mpin',
                //             defaultValue: 'MOTOR_1',
                //         },
                //     },
                // }, {
                //     opcode: 'motorSpeed',
                //     runMode: 1, // 0,
                //     text: '直流电机速度[PIN]',
                //     blockType: BlockType.REPORTER,
                //     arguments: {
                //         PIN: {
                //             type: ArgumentType.STRING,
                //             menu: 'mpin',
                //             defaultValue: 'MOTOR_1',
                //         },
                //     },
                // }, {
                //     opcode: 'dhtValue',
                //     runMode: 1, // 0,
                //     text: '[DHT][TYPE]值[PIN]',
                //     blockType: BlockType.REPORTER,
                //     arguments: {
                //         DHT: {
                //             type: ArgumentType.STRING,
                //             menu: 'dht',
                //             defaultValue: 'DHT11',
                //         },
                //         TYPE: {
                //             type: ArgumentType.STRING,
                //             menu: 'dhttype',
                //             defaultValue: 'temperature',
                //         },
                //         PIN: {
                //             type: ArgumentType.STRING,
                //             menu: 'dhtpin',
                //             defaultValue: '8',
                //         }
                //     },
                // }, {
                //     opcode: 'hcsr04Value',
                //     runMode: 1, // 0,
                //     text: 'HC-SR04 距离(毫米) trigger[TRIGGER]echo[ECHO]',
                //     blockType: BlockType.REPORTER,
                //     arguments: {
                //         TRIGGER: {
                //             type: ArgumentType.STRING,
                //             menu: 'pin_output',
                //             defaultValue: '0',
                //         },
                //         ECHO: {
                //             type: ArgumentType.STRING,
                //             menu: 'pin_output',
                //             defaultValue: '1',
                //         }
                //     },
                // },
                // // 点阵屏
                // {
                //     opcode: 'displayMatrix',
                //     runMode: 1, //0,
                //     blockType: BlockType.COMMAND, // ArgumentType BOOLEAN, BOOLEAN, COMMAND, MATRIX8
                //     text: '点阵屏自定义图形 [MATRIX8]',
                //     arguments: {
                //         MATRIX8: {
                //             type: ArgumentType.MATRIX8, // ArgumentType.MATRIX8,
                //             defaultValue: '0001100000111100011111101101101100011000000110000001100000011000'
                //             // defaultValue: '0000000000000000000000000000000000000000000000000000000000000000'
                //         }
                //     }
                // }, {
                //     opcode: 'displayImage',
                //     runMode: 1,// 0,
                //     blockType: BlockType.COMMAND, // BlockType COMMAND
                //     text: '点阵屏预设图形 [image]',
                //     arguments: {
                //         image: {
                //             type: ArgumentType.STRING,
                //             menu: 'image',
                //             defaultValue: '0100001011100111111111111111111111111111011111100011110000011000'
                //         }
                //     }
                // }, {
                //     opcode: 'displayBrightness',
                //     runMode: 1, // 0,
                //     blockType: BlockType.COMMAND, // BlockType COMMAND
                //     text: '点阵屏亮度等级 [level]',
                //     arguments: {
                //         level: {
                //             type: ArgumentType.NUMBER,
                //             defaultValue: 0,
                //         },
                //     }
                // },
                // {
                //     opcode: 'displayType',
                //     runMode: 1,// 0,
                //     blockType: BlockType.COMMAND, // BlockType COMMAND
                //     text: '点阵屏 [DISPLAYTYPE]',
                //     arguments: {
                //         DISPLAYTYPE: {
                //             type: ArgumentType.NUMBER,
                //             menu: 'displaytype',
                //             defaultValue: 1,
                //         },
                //     }
                // },
                // 灯带 neopixel
                // {
                //     opcode: 'neopixel_init',
                //     runMode: 1, // 0,
                //     text: '灯带初始化 引脚[PIN] 数量[COUNT]',
                //     blockType: BlockType.COMMAND,
                //     arguments: {
                //         PIN: {
                //             type: ArgumentType.NUMBER,
                //             menu: 'neopixelpin',
                //             defaultValue: 7,
                //         },
                //         COUNT: {
                //             type: ArgumentType.NUMBER,
                //             defaultValue: 8,
                //         },
                //     },
                // },
                // {
                //     opcode: 'neopixel_set_color',
                //     runMode: 1, // 0,
                //     text: '灯带 [INDEX]号 颜色为[COLOR]',
                //     blockType: BlockType.COMMAND,
                //     arguments: {
                //         INDEX: {
                //             type: ArgumentType.NUMBER,
                //             defaultValue: 0,
                //         },
                //         COLOR: {type: ArgumentType.COLORRGB},
                //     },
                // },
                // {
                //     opcode: 'neopixel_set_color_num',
                //     runMode: 1, // 0,
                //     text: '灯带 [INDEX]号 红[R] 绿[G] 蓝[B]',
                //     blockType: BlockType.COMMAND,
                //     arguments: {
                //         INDEX: {
                //             type: ArgumentType.NUMBER,
                //             defaultValue: 0,
                //         },
                //         R: {
                //             type: ArgumentType.NUMBERRANGE,
                //             defaultValue: 255,
                //         },
                //         G: {
                //             type: ArgumentType.NUMBERRANGE,
                //             defaultValue: 0,
                //         },
                //         B: {
                //             type: ArgumentType.NUMBERRANGE,
                //             defaultValue: 0,
                //         },
                //     },
                // },
                // {
                //     opcode: 'neopixel_set_all_color',
                //     runMode: 1, // 0,
                //     text: '灯带全亮 颜色为[COLOR]',
                //     blockType: BlockType.COMMAND,
                //     arguments: {
                //         COLOR: {type: ArgumentType.COLORRGB},
                //     },
                // },
                // {
                //     opcode: 'neopixel_set_all_color_num',
                //     runMode: 1, // 0,
                //     text: '灯带全亮  红[R] 绿[G] 蓝[B]',
                //     blockType: BlockType.COMMAND,
                //     arguments: {
                //         R: {
                //             type: ArgumentType.NUMBERRANGE,
                //             defaultValue: 255,
                //         },
                //         G: {
                //             type: ArgumentType.NUMBERRANGE,
                //             defaultValue: 0,
                //         },
                //         B: {
                //             type: ArgumentType.NUMBERRANGE,
                //             defaultValue: 0,
                //         },
                //     },
                // },
                // {
                //     opcode: 'neopixel_take_effect',
                //     runMode: 1, // 0,
                //     text: '灯带设置生效',
                //     blockType: BlockType.COMMAND,
                //     arguments: {},
                // },
                // {
                //     opcode: 'neopixel_all_off',
                //     runMode: 1, // 0,
                //     text: '灯带关闭',
                //     blockType: BlockType.COMMAND,
                //     arguments: {},
                // },
                // {
                //     opcode: 'neopixel_set_brightness',
                //     runMode: 1, // 0,
                //     text: '灯带亮度 设置为[BRIGHTNESS]',
                //     blockType: BlockType.COMMAND,
                //     arguments: {
                //         BRIGHTNESS: {
                //             type: ArgumentType.NUMBER,
                //             defaultValue: 30,
                //         },
                //     },
                // },
                // {
                //     opcode: 'neopixel_make_rainbow',
                //     runMode: 1, // 0,
                //     text: '灯带彩虹灯效 数量[COUNT] 亮度[BRIGHTNESS] 偏移[OFFSET]',
                //     blockType: BlockType.COMMAND,
                //     arguments: {
                //         COUNT: {
                //             type: ArgumentType.NUMBER,
                //             defaultValue: 8,
                //         },
                //         BRIGHTNESS: {
                //             type: ArgumentType.NUMBER,
                //             defaultValue: 30,
                //         },
                //         OFFSET: {
                //             type: ArgumentType.NUMBER,
                //             defaultValue: 1,
                //         }
                //     },
                // },
                'SIoT',
                {
                    opcode: 'connectSIoT',
                    runMode: 1, // 0,
                    blockType: BlockType.COMMAND,
                    text: 'SIoT 创建连接 客户端ID[ID] 服务器[SERVER]用户[USER]密码[PASSWORD]',
                    arguments: {
                        ID: {
                            type: ArgumentType.STRING,
                            defaultValue: 'ABC',
                        },
                        SERVER: {
                            type: ArgumentType.STRING,
                            defaultValue: '192.168.1.154',
                        },
                        USER: {
                            type: ArgumentType.STRING,
                            defaultValue: 'siot',
                        },
                        PASSWORD: {
                            type: ArgumentType.STRING,
                            defaultValue: '12345678',
                        },
                    },
                }, {
                    opcode: 'SIoTStatus',
                    runMode: 1, // 0,
                    blockType: BlockType.REPORTER,
                    text: 'SIoT 连接状态',
                }, {
                    opcode: 'hasConnectedSIoT',
                    runMode: 1, // 0,
                    blockType: BlockType.BOOLEAN,
                    text: 'SIoT 连接成功？',
                }, {
                    opcode: 'subscribeSIot',
                    runMode: 1, // 0,
                    blockType: BlockType.COMMAND,
                    text: 'SIoT 订阅 [TOPIC] 命名为 [TOPICNAME]',
                    arguments: {
                        TOPIC: {
                            type: ArgumentType.STRING,
                            menu: 'SIoTtopic',
                            defaultValue: 'topic_1'
                        },
                        TOPICNAME: {
                            type: ArgumentType.STRING,
                            defaultValue: ''
                        },
                    },
                }, {
                    opcode: 'publishSIoT',
                    runMode: 1, // 0,
                    blockType: BlockType.COMMAND,
                    text: 'SIoT 发送消息[MESSAGE]到[TOPIC]',
                    arguments: {
                        MESSAGE: {
                            type: ArgumentType.STRING,
                            defaultValue: ''
                        },
                        TOPIC: {
                            type: ArgumentType.STRING,
                            menu: 'SIoTtopic',
                            defaultValue: 'topic_1'
                        },
                        
                    },
                },

                'BLE UART',
                {
                    opcode: 'createBLE',
                    blockType: BlockType.COMMAND,
                    text: '构建 BLE UART从机 显示名称 [BLENAME]',
                    arguments: {
                        BLENAME: {
                            type: ArgumentType.STRING,
                            defaultValue: ''
                        },
                    },
                }, {
                    opcode: 'whenBLERecieveMsg',
                    text: '当 BLE UART 接收到数据时',
                    blockType: BlockType.HAT,
                    arguments: {
                    }
                }, {
                    opcode: 'BLEMsg',
                    blockType: BlockType.REPORTER,
                    text: 'BLE UART 接收的数据',
                }, {
                    opcode: 'BLESendMsg',
                    blockType: BlockType.COMMAND,
                    text: 'BLE UART发送数据[MSG]',
                    arguments: {
                        MSG: {
                            type: ArgumentType.STRING,
                            defaultValue: ''
                        },
                    },
                },

                'I2C射频卡',
                {
                    opcode: 'initDigitalWallet',
                    blockType: BlockType.COMMAND,
                    text: 'I2C射频卡 初始化电子钱包',
                    arguments: {
                    },
                }, {
                    opcode: 'I2CScan',
                    blockType: BlockType.COMMAND,
                    text: 'I2C射频卡 扫描',
                    arguments: {
                    },
                }, {
                    opcode: 'I2CScanData',
                    blockType: BlockType.BOOLEAN,
                    text: 'I2C射频卡 扫描数据',
                    arguments: {
                    },
                }, {
                    opcode: 'I2CTouchBLE',
                    blockType: BlockType.COMMAND,
                    text: 'I2C射频卡 碰触 BLE UART',
                    arguments: {
                    },
                }, {
                    opcode: 'I2CLeaveBLE',
                    blockType: BlockType.COMMAND,
                    text: 'I2C射频卡 离开 BLE UART',
                    arguments: {
                    },
                }, {
                    opcode: 'I2CChangeDigitalWallet',
                    blockType: BlockType.COMMAND,
                    text: 'I2C射频卡 给电子钱包[CHANGE]金额[BALANCE]',
                    arguments: {
                        CHANGE: {
                            type: ArgumentType.STRING,
                            menu: 'WALLET_CHANGE',
                            defaultValue: '充值'
                        },
                        BALANCE: {
                            type: ArgumentType.STRING,
                            defaultValue: ''
                            
                        }
                    },
                }, {
                    opcode: 'I2CWalletBalance',
                    blockType: BlockType.REPORTER,
                    text: 'I2C射频卡 电子钱包余额',
                    arguments: {
                    },
                },
                
                // MQTT
                // {
                //     blockType: BlockType.STRING,
                //     runMode: 1, // 0,
                //     text: 'MQTT'
                // }, {
                //     opcode: 'connectMQTT',
                //     runMode: 1, // 0,
                //     blockType: BlockType.COMMAND,
                //     text: 'MQTT 连接 服务器[SERVER]用户[USER]密码[PASSWORD]',
                //     arguments: {
                //         SERVER: {
                //             type: ArgumentType.STRING,
                //             defaultValue: '',
                //         },
                //         USER: {
                //             type: ArgumentType.STRING,
                //             defaultValue: '',
                //         },
                //         PASSWORD: {
                //             type: ArgumentType.STRING,
                //             defaultValue: '',
                //         },
                //     },
                // }, {
                //     opcode: 'hasConnectedMQTT',
                //     runMode: 1, // 0,
                //     blockType: BlockType.BOOLEAN,
                //     text: 'MQTT 连接成功？',
                // }, {
                //     opcode: 'subscribeMQTT',
                //     runMode: 1, // 0,
                //     blockType: BlockType.COMMAND,
                //     text: 'MQTT 订阅 主题1[TOPIC_1]主题2[TOPIC_2]主题3[TOPIC_3]',
                //     arguments: {
                //         TOPIC_1: {
                //             type: ArgumentType.STRING,
                //             defaultValue: '',
                //         },
                //         TOPIC_2: {
                //             type: ArgumentType.STRING,
                //             defaultValue: '',
                //         },
                //         TOPIC_3: {
                //             type: ArgumentType.STRING,
                //             defaultValue: '',
                //         },
                //     },
                // }, {
                //     opcode: 'disconnectMQTT',
                //     runMode: 1, // 0,
                //     blockType: BlockType.COMMAND,
                //     text: 'MQTT 断开连接',
                // }, {
                //     opcode: 'publishMQTT',
                //     runMode: 1, // 0,
                //     blockType: BlockType.COMMAND,
                //     text: 'MQTT 发送消息[MSG]到[TOPIC]',
                //     arguments: {
                //         MSG: {
                //             type: ArgumentType.STRING,
                //             defaultValue: '',
                //         },
                //         TOPIC: {
                //             type: ArgumentType.STRING,
                //             menu: 'MQTTtopic',
                //             defaultValue: '_topic_1',
                //         },
                //     },
                // }, {
                //     opcode: 'messageMQTT',
                //     runMode: 1, // 0,
                //     blockType: BlockType.REPORTER,
                //     text: 'MQTT 消息',
                //     disableMonitor: true,
                //     // hideFromPalette: true
                // }, {
                //     opcode: 'receiveMQTT',
                //     runMode: 1, // 0,
                //     text: '当接收到[TOPIC]的 [MESSAGE]',
                //     blockType: BlockType.HAT,
                //     arguments: {
                //         MESSAGE: {
                //             type: 'messageMQTT'
                //         },
                //         TOPIC: {
                //             type: ArgumentType.STRING,
                //             menu: 'MQTTtopic',
                //             defaultValue: '_topic_1',
                //         },
                //     },
                // },
                '心知天气',
                {
                    opcode: 'seniverse_search',
                    blockType: BlockType.REPORTER,
                    text: '心知天气 查询天气 API私钥[APIKEY] 城市[LOCATION] 的 [CLASSIFY]',
                    arguments: {
                        APIKEY: {
                            type: ArgumentType.STRING,
                            defaultValue: 'SXuiAbZQ5ebuLxlDC',
                        },
                        LOCATION: {
                            type: ArgumentType.STRING,
                            defaultValue: '北京'
                        },
                        CLASSIFY: {
                            type: ArgumentType.STRING,
                            menu: 'SENIVERSE_CLASSIFY',
                            defaultValue: '天气',
                        },
                    },
                },
                {
                    opcode: 'seniverse_daily',
                    blockType: BlockType.REPORTER,
                    text: '心知天气 查询明日天气 API私钥[APIKEY] 城市[LOCATION] 的 [CLASSIFY]',
                    arguments: {
                        APIKEY: {
                            type: ArgumentType.STRING,
                            defaultValue: 'SXuiAbZQ5ebuLxlDC',
                        },
                        LOCATION: {
                            type: ArgumentType.STRING,
                            defaultValue: '北京'
                        },
                        CLASSIFY: {
                            type: ArgumentType.STRING,
                            menu: 'SENIVERSE_DAILY_CLASSIFY',
                            defaultValue: '白天天气',
                        },
                    },
                },

                '基础组件',
                {
                    opcode: 'openHandpyModal',
                    blockType: BlockType.COMMAND,
                    text: '打开智能开发板窗口'
                },
                {
                    opcode: 'closeHandpyModal',
                    blockType: BlockType.COMMAND,
                    text: '关闭智能开发板窗口'
                },
                {
                    opcode: 'openHandpyWebsiteModal',
                    blockType: BlockType.COMMAND,
                    text: '打开网页窗口'
                },
                {
                    opcode: 'closeHandpyWebsiteModal',
                    blockType: BlockType.COMMAND,
                    text: '关闭网页窗口'
                },
                {
                    opcode: 'openHandpyMobileBtn',
                    blockType: BlockType.COMMAND,
                    text: '打开远程指令APP'
                },
                {
                    opcode: 'closeHandpyMobileBtn',
                    blockType: BlockType.COMMAND,
                    text: '关闭远程指令APP'
                },
                {
                    opcode: 'openHandpyMobileMsg',
                    blockType: BlockType.COMMAND,
                    text: '打开接收数据APP'
                },
                {
                    opcode: 'closeHandpyMobileMsg',
                    blockType: BlockType.COMMAND,
                    text: '关闭接收数据APP'
                },
                
                
            ],

            menus: {
                button_touchkey: {
                    acceptReporters: true,
                    // BUTTON_TOUCHKEY_MENU
                    items: [
                        {text: 'A', value: 'A'},
                        {text: 'B', value: 'B'},
                        {text: 'P', value: 'P'},
                        {text: 'Y', value: 'Y'},
                        {text: 'T', value: 'T'},
                        {text: 'H', value: 'H'},
                        {text: 'O', value: 'O'},
                        {text: 'N', value: 'N'}
                    ]
                },
                buttons: {
                    acceptReporters: true,
                    // BUTTONS_MENU
                    items: [
                        {text: 'A', value: 'A'},
                        {text: 'B', value: 'B'}
                    ]
                },
                buttonstate: {
                    acceptReporters: true,
                    // BUTTONSTATE_MENU
                    items: [
                        {
                            text: '被点击',
                            value: 'pressed'
                        }, {
                            text: '被释放',
                            value: 'released'
                        }
                    ]
                },
                touchkeys: {
                    acceptReporters: true,
                    // TOUCHKEYS_MENU
                    items: [
                        {text: 'P', value: 'P'},
                        {text: 'Y', value: 'Y'},
                        {text: 'T', value: 'T'},
                        {text: 'H', value: 'H'},
                        {text: 'O', value: 'O'},
                        {text: 'N', value: 'N'}
                    ]
                },
                gestures: {
                    acceptReporters: true,
                    // GESTURES_MENU
                    items: [
                        {
                            text: '摇晃',
                            value: 'shaken'
                        }, {
                            text: '抛起',
                            value: 'jumped'
                        }, {
                            text: '向前倾斜',
                            value: 'tilted_front'
                        }, {
                            text: '向后倾斜',
                            value: 'tilted_back'
                        }, {
                            text: '向左倾斜',
                            value: 'tilted_left'
                        }, {
                            text: '向右倾斜',
                            value: 'tilted_right'
                        }
                    ]
                },
                tilted: {
                    acceptReporters: true,
                    // TILTED_MENU
                    items: [{
                        text: '向前倾斜',
                        value: 'tilted_front'
                    },
                    {
                        text: '向后倾斜',
                        value: 'tilted_back'
                    },
                    {
                        text: '向左倾斜',
                        value: 'tilted_left'
                    },
                    {
                        text: '向右倾斜',
                        value: 'tilted_right'
                    }],
                },
                pins: {
                    acceptReporters: true,
                    items: [
                        {text: 'P0', value: '0'},
                        {text: 'P1', value: '1'},
                        {text: 'P2', value: '2'},
                        {text: 'P3 (EXT)', value: '3'},
                        {text: 'P7', value: '7'},
                        {text: 'P8', value: '8'},
                        {text: 'P9', value: '9'},
                        {text: 'P13', value: '13'},
                        {text: 'P14', value: '14'},
                        {text: 'P15', value: '15'},
                        {text: 'P16', value: '16'}
                    ]
                },
                pin_output: {
                    acceptReporters: true,
                    items: [
                        {text: 'P0', value: '0'},
                        {text: 'P1', value: '1'},
                        {text: 'P8', value: '8'},
                        {text: 'P9', value: '9'},
                        {text: 'P13', value: '13'},
                        {text: 'P14', value: '14'},
                        {text: 'P15', value: '15'},
                        {text: 'P16', value: '16'}
                    ]
                },
                pin_music: {
                    acceptReporters: true,
                    items: [
                        {text: '默认', value: '6'},
                        {text: 'P0', value: '0'},
                        {text: 'P1', value: '1'},
                        {text: 'P8', value: '8'},
                        {text: 'P9', value: '9'},
                        {text: 'P13', value: '13'},
                        {text: 'P14', value: '14'},
                        {text: 'P15', value: '15'},
                        {text: 'P16', value: '16'}
                    ]
                },
                pin_digital_state: {
                    acceptReporters: true,
                    items: [
                        {text: 'HIGH', value: '1'},
                        {text: 'LOW', value: '0'}
                    ]
                },
                pin_get_analog: {
                    acceptReporters: true,
                    items: [
                        {text: 'P0', value: '0'},
                        {text: 'P1', value: '1'},
                        {text: 'P2', value: '2'},
                        {text: 'P3 (EXT)', value: '3'}
                    ]
                },
                pinaction: {
                    acceptReporters: true,
                    // PIN_ACTION_MENU
                    items: [
                        {
                            text: '↗ 从低到高',
                            value: 'to_high'
                        }, {
                            text: '↘ 从高到低',
                            value: 'to_low'
                        }
                    ]
                },
                axes: {
                    acceptReporters: true,
                    // AXES_MENU
                    items: [
                        {
                            text: 'X轴',
                            value: 'X'
                        }, {
                            text: 'Y轴',
                            value: 'Y'
                        }, {
                            text: 'Z轴',
                            value: 'Z'
                        }
                    ]
                },
                axes_g: {
                    acceptReporters: true,
                    // AXES_G_MENU
                    items: [
                        {
                            text: 'X轴',
                            value: 'X'
                        }, {
                            text: 'Y轴',
                            value: 'Y'
                        }, {
                            text: 'Z轴',
                            value: 'Z'
                        }, {
                            text: '重力',
                            value: 'G'
                        }
                    ]
                },
                axes_m: {
                    acceptReporters: true,
                    // AXES_M_MENU
                    items: [
                        {
                            text: 'X轴',
                            value: 'X'
                        }, {
                            text: 'Y轴',
                            value: 'Y'
                        }, {
                            text: 'Z轴',
                            value: 'Z'
                        }, {
                            text: '计算后的',
                            value: 'M'
                        }
                    ]
                },
                acceleration_range: {
                    acceptReporters: true,
                    items: [
                        {text: '±2G', value: '2G'},
                        {text: '±4G', value: '4G'},
                        {text: '±8G', value: '8G'},
                        {text: '±16G', value: '16G'}
                    ]
                },
                second_type: {
                    acceptReporters: true,
                    // SECOND_TYPE_MENU
                    items: [
                        {
                            text: '秒',
                            value: 'second'
                        }, {
                            text: '毫秒(1/1000秒)',
                            value: 'millisecond'
                        }, {
                            text: '微秒(1/1000毫秒)',
                            value: 'microsecond'
                        }
                    ]
                },
                localtime_type: {
                    acceptReporters: true,
                    // LOCALTIME_TYPE_MENU
                    items: [
                        {
                            text: '年',
                            value: 'year'
                        }, {
                            text: '月',
                            value: 'month'
                        }, {
                            text: '日',
                            value: 'date'
                        }, {
                            text: '时',
                            value: 'hour'
                        }, {
                            text: '分',
                            value: 'minute'
                        }, {
                            text: '秒',
                            value: 'second'
                        }, {
                            text: '星期数',
                            value: 'week'
                        }, {
                            text: '日期数',
                            value: 'dates'
                        }
                    ]
                },
                rgbs: {
                    acceptReporters: true,
                    // RGBS_MENU
                    items: [
                        {text: '0 #', value: '0'},
                        {text: '1 #', value: '1'},
                        {text: '2 #', value: '2'},
                        {text: 'ALL', value: 'ALL'}
                    ]
                },
                brightness: {
                    acceptReporters: true,
                    items: [
                        '9',
                        '8',
                        '7',
                        '6',
                        '5',
                        '4',
                        '3',
                        '2',
                        '1'
                    ]
                },
                sensors: {
                    acceptReporters: true,
                    // SENSORS_MENU
                    items: [
                        {
                            text: '光线',
                            value: 'light'
                        }, {
                            text: '声音',
                            value: 'sound'
                        }
                    ]
                },
                oledclear: {
                    acceptReporters: true,
                    // OLED_CLEAR_MENU
                    items: [
                        {
                            text: '清空',
                            value: 'clear'
                        },
                        {
                            text: '全亮',
                            value: 'full_bright'
                        },
                        {
                            text: '黑底',
                            value: 'black_background'
                        },
                        {
                            text: '白底',
                            value: 'white_background'
                        }
                    ]
                },
                oledlines: {
                    acceptReporters: true,
                    items: ['1', '2', '3', '4']
                },
                oledpointmode: {
                    acceptReporters: true,
                    // OLED_POINT_MODE_MENU
                    items: [
                        {
                            text: '亮',
                            value: '1'
                        },
                        {
                            text: '暗',
                            value: '0'
                        }
                    ]
                },
                oleddrawdirection: {
                    acceptReporters: true,
                    // OLED_DRAW_DIRECTION_MENU
                    items: [
                        {
                            text: '垂直',
                            value: '0'
                        }, {
                            text: '水平',
                            value: '1'
                        }
                    ]
                },
                oleddrawmethod: {
                    acceptReporters: true,
                    // OLED_DRAW_METHOD_MENU
                    items: [
                        {
                            text: '绘制',
                            value: '1'
                        },
                        {
                            text: '擦除',
                            value: '0'
                        }
                    ]
                },
                oledfillmode: {
                    acceptReporters: true,
                    // OLED_FILL_MODE_MENU
                    items: [
                        {
                            text: '空心',
                            value: '_',
                        }, {
                            text: '实心',
                            value: 'fill_',
                        },
                    ],
                    
                },
                innerimage: {
                    acceptReporters: true,
                    items: [
                        {
                            text: '爱心',
                            value: "'face/Expressions/Heart large.pbm'"
                        }, {
                            text: '爱心(小)',
                            value: "'face/Expressions/Heart small.pbm'"
                        }, {
                            text: '牙齿张开1',
                            value: "'face/Expressions/Mouth 1 open.pbm'"
                        }, {
                            text: '牙齿紧闭1',
                            value: "'face/Expressions/Mouth 1 shut.pbm'"
                        }, {
                            text: '牙齿张开2',
                            value: "'face/Expressions/Mouth 2 open.pbm'"
                        }, {
                            text: '牙齿紧闭2',
                            value: "'face/Expressions/Mouth 2 shut.pbm'"
                        }, {
                            text: '笑脸',
                            value: "'face/Expressions/Big smile.pbm'"
                        }, {
                            text: '悲伤',
                            value: "'face/Expressions/Sad.pbm'"
                        }, {
                            text: '不舒服',
                            value: "'face/Expressions/Sick.pbm'"
                        }, {
                            text: '微笑',
                            value: "'face/Expressions/Smile.pbm'"
                        }, {
                            text: '喋喋不休',
                            value: "'face/Expressions/Swearing.pbm'"
                        }, {
                            text: '话题',
                            value: "'face/Expressions/Talking.pbm'"
                        }, {
                            text: '眨眼',
                            value: "'face/Expressions/Wink.pbm'"
                        }, {
                            text: '睡觉',
                            value: "'face/Expressions/ZZZ.pbm'"
                        }, {
                            text: '愤怒',
                            value: "'face/Eyes/Angry.pbm'"
                        }, {
                            text: '睡醒',
                            value: "'face/Eyes/Awake.pbm'"
                        }, {
                            text: '失望',
                            value: "'face/Eyes/Disappointed.pbm'"
                        }, {
                            text: '讨厌',
                            value: "'face/Eyes/Evil.pbm'"
                        }, {
                            text: '受伤',
                            value: "'face/Eyes/Hurt.pbm'"
                        }, {
                            text: '黑眼圈',
                            value: "'face/Eyes/Black eye.pbm'"
                        }, {
                            text: '原子能',
                            value: "'face/Eyes/Nuclear.pbm'"
                        }, {
                            text: '晕眩',
                            value: "'face/Eyes/Dizzy.pbm'"
                        }, {
                            text: '麻醉',
                            value: "'face/Eyes/Knocked out.pbm'"
                        }, {
                            text: '爱',
                            value: "'face/Eyes/Love.pbm'"
                        }, {
                            text: '中毒',
                            value: "'face/Eyes/Toxic.pbm'"
                        }, {
                            text: '发疯1',
                            value: "'face/Eyes/Crazy 1.pbm'"
                        }, {
                            text: '发疯2',
                            value: "'face/Eyes/Crazy 2.pbm'"
                        }, {
                            text: '上看看1',
                            value: "'face/Eyes/Up.pbm'"
                        }, {
                            text: '下看看1',
                            value: "'face/Eyes/Down.pbm'"
                        }, {
                            text: '左看看1',
                            value: "'face/Eyes/Middle left.pbm'"
                        }, {
                            text: '右看看1',
                            value: "'face/Eyes/Middle right.pbm'"
                        }, {
                            text: '左下角看1',
                            value: "'face/Eyes/Bottom left.pbm'"
                        }, {
                            text: '右下角看1',
                            value: "'face/Eyes/Bottom right.pbm'"
                        }, {
                            text: '直视1',
                            value: "'face/Eyes/Neutral.pbm'"
                        }, {
                            text: '上看看2(流泪)',
                            value: "'face/Eyes/Tear.pbm'"
                        }, {
                            text: '下看看2',
                            value: "'face/Eyes/Tired middle.pbm'"
                        }, {
                            text: '左看看2',
                            value: "'face/Eyes/Pinch left.pbm'"
                        }, {
                            text: '右看看2',
                            value: "'face/Eyes/Pinch right.pbm'"
                        }, {
                            text: '左下角看2',
                            value: "'face/Eyes/Tired left.pbm'"
                        }, {
                            text: '右下角看2',
                            value: "'face/Eyes/Tired right.pbm'"
                        }, {
                            text: '直视2',
                            value: "'face/Eyes/Pinch middle.pbm'"
                        }, {
                            text: '一只眼',
                            value: "'face/Eyes/Winking.pbm'"
                        }, {
                            text: '打勾',
                            value: "'face/Information/Accept.pbm'"
                        }, {
                            text: '错误',
                            value: "'face/Information/Decline.pbm'"
                        }, {
                            text: '箭头向上',
                            value: "'face/Information/Forward.pbm'"
                        }, {
                            text: '箭头向下',
                            value: "'face/Information/Backward.pbm'"
                        }, {
                            text: '箭头向左',
                            value: "'face/Information/Left.pbm'"
                        }, {
                            text: '箭头向右',
                            value: "'face/Information/Right.pbm'"
                        }, {
                            text: '禁止',
                            value: "'face/Information/No go.pbm'"
                        }, {
                            text: '警告',
                            value: "'face/Information/Warning.pbm'"
                        }, {
                            text: '问号',
                            value: "'face/Information/Question mark.pbm'"
                        }, {
                            text: '停止1',
                            value: "'face/Information/Stop 1.pbm'"
                        }, {
                            text: '停止2',
                            value: "'face/Information/Stop 2.pbm'"
                        }, {
                            text: '拇指向下',
                            value: "'face/Information/Thumbs down.pbm'"
                        }, {
                            text: '拇指向上',
                            value: "'face/Information/Thumbs up.pbm'"
                        }, {
                            text: '炸弹',
                            value: "'face/Objects/Bomb.pbm'"
                        }, {
                            text: '爆炸',
                            value: "'face/Objects/Boom.pbm'"
                        }, {
                            text: '火',
                            value: "'face/Objects/Fire.pbm'"
                        }, {
                            text: '花儿',
                            value: "'face/Objects/Flowers.pbm'"
                        }, {
                            text: '森林',
                            value: "'face/Objects/Forest.pbm'"
                        }, {
                            text: '关灯',
                            value: "'face/Objects/Light off.pbm'"
                        }, {
                            text: '开灯',
                            value: "'face/Objects/Light on.pbm'"
                        }, {
                            text: '闪电',
                            value: "'face/Objects/Lightning.pbm'"
                        }, {
                            text: '夜晚',
                            value: "'face/Objects/Night.pbm'"
                        }, {
                            text: '海盗',
                            value: "'face/Objects/Pirate.pbm'"
                        }, {
                            text: '下雪',
                            value: "'face/Objects/Snow.pbm'"
                        }, {
                            text: '靶子',
                            value: "'face/Objects/Target.pbm'"
                        }, {
                            text: '进度条0%',
                            value: "'face/Progress/Bar 0.pbm'"
                        }, {
                            text: '进度条25%',
                            value: "'face/Progress/Bar 1.pbm'"
                        }, {
                            text: '进度条50%',
                            value: "'face/Progress/Bar 2.pbm'"
                        }, {
                            text: '进度条75%',
                            value: "'face/Progress/Bar 3.pbm'"
                        }, {
                            text: '进度条100%',
                            value: "'face/Progress/Bar 4.pbm'"
                        }, {
                            text: '刻度盘1',
                            value: "'face/Progress/Dial 0.pbm'"
                        }, {
                            text: '刻度盘2',
                            value: "'face/Progress/Dial 1.pbm'"
                        }, {
                            text: '刻度盘3',
                            value: "'face/Progress/Dial 2.pbm'"
                        }, {
                            text: '刻度盘4',
                            value: "'face/Progress/Dial 3.pbm'"
                        }, {
                            text: '刻度盘5',
                            value: "'face/Progress/Dial 4.pbm'"
                        }, {
                            text: '结核1',
                            value: "'face/Progress/Dots 0.pbm'"
                        }, {
                            text: '结核2',
                            value: "'face/Progress/Dots 1.pbm'"
                        }, {
                            text: '结核3',
                            value: "'face/Progress/Dots 2.pbm'"
                        }, {
                            text: '结核4',
                            value: "'face/Progress/Dots 3.pbm'"
                        }, {
                            text: '沙漏1',
                            value: "'face/Progress/Hourglass 0.pbm'"
                        }, {
                            text: '沙漏2',
                            value: "'face/Progress/Hourglass 1.pbm'"
                        }, {
                            text: '沙漏3',
                            value: "'face/Progress/Hourglass 2.pbm'"
                        }, {
                            text: '闹钟1',
                            value: "'face/Progress/Timer 0.pbm'"
                        }, {
                            text: '闹钟2',
                            value: "'face/Progress/Timer 1.pbm'"
                        }, {
                            text: '闹钟3',
                            value: "'face/Progress/Timer 2.pbm'"
                        }, {
                            text: '闹钟4',
                            value: "'face/Progress/Timer 3.pbm'"
                        }, {
                            text: '闹钟5',
                            value: "'face/Progress/Timer 4.pbm'"
                        }, {
                            text: '水位1',
                            value: "'face/Progress/Water level 0.pbm'"
                        }, {
                            text: '水位2',
                            value: "'face/Progress/Water level 1.pbm'"
                        }, {
                            text: '水位3',
                            value: "'face/Progress/Water level 2.pbm'"
                        }, {
                            text: '水位4',
                            value: "'face/Progress/Water level 3.pbm'"
                        }, {
                            text: '同意1',
                            value: "'face/System/Accept_1.pbm'"
                        }, {
                            text: '同意2',
                            value: "'face/System/Accept_2.pbm'"
                        }, {
                            text: '警示',
                            value: "'face/System/Alert.pbm'"
                        }, {
                            text: '箱子',
                            value: "'face/System/Box.pbm'"
                        }, {
                            text: '沙漏1(小)',
                            value: "'face/System/Busy_0.pbm'"
                        }, {
                            text: '沙漏2(小)',
                            value: "'face/System/Busy_1.pbm'"
                        }, {
                            text: '不同意1',
                            value: "'face/System/Decline_1.pbm'"
                        }, {
                            text: '不同意2',
                            value: "'face/System/Decline_2.pbm'"
                        }, {
                            text: '空心圆',
                            value: "'face/System/Dot_empty.pbm'"
                        }, {
                            text: '实心圆',
                            value: "'face/System/Dot_full.pbm'"
                        }, {
                            text: '播放',
                            value: "'face/System/Play.pbm'"
                        }, {
                            text: '滑杆1',
                            value: "'face/System/Slider_0.pbm'"
                        }, {
                            text: '滑杆2',
                            value: "'face/System/Slider_1.pbm'"
                        }, {
                            text: '滑杆3',
                            value: "'face/System/Slider_2.pbm'"
                        }, {
                            text: '滑杆4',
                            value: "'face/System/Slider_3.pbm'"
                        }, {
                            text: '滑杆5',
                            value: "'face/System/Slider_4.pbm'"
                        }, {
                            text: '滑杆6',
                            value: "'face/System/Slider_5.pbm'"
                        }, {
                            text: '滑杆7',
                            value: "'face/System/Slider_6.pbm'"
                        }, {
                            text: '滑杆8',
                            value: "'face/System/Slider_7.pbm'"
                        }, {
                            text: '滑杆9',
                            value: "'face/System/Slider_8.pbm'"
                        }, {
                            text: '石头',
                            value: "'face/rock.pbm'"
                        }, {
                            text: '石头(小)',
                            value: "'face/rock_s.pbm'"
                        }, {
                            text: '剪刀',
                            value: "'face/scissors.pbm'"
                        }, {
                            text: '剪刀(小)',
                            value: "'face/scissors_s.pbm'"
                        }, {
                            text: '布',
                            value: "'face/paper.pbm'"
                        }, {
                            text: '布(小)',
                            value: "'face/paper_s.pbm'"
                        }
                    ]
                },
                beats: {
                    acceptReporters: true,
                    items: [
                        {text: '1/4', value: '1'},
                        {text: '1/2', value: '2'},
                        {text: '3/4', value: '3'},
                        {text: '1', value: '4'},
                        {text: '1.5', value: '6'},
                        {text: '2', value: '8'},
                        {text: '3', value: '12'},
                        {text: '4', value: '16'}
                    ]
                },
                music_octave: {
                    acceptReporters: true,
                    items: [
                        {
                            text: '正常',
                            value: '0',
                        },
                        {
                            text: '高八度',
                            value: '12',
                        },
                        {
                            text: '低八度',
                            value: '-12',
                        },
                    ],
                },
                innermusic: {
                    acceptReporters: true,
                    items: [
                        'DADADADUM',
                        'ENTERTAINER',
                        'PRELUDE',
                        'ODE',
                        'NYAN',
                        'RINGTONE',
                        'FUNK',
                        'BLUES',
                        'BIRTHDAY',
                        'WEDDING',
                        'FUNERAL',
                        'PUNCHLINE',
                        'PYTHON',
                        'BADDY',
                        'CHASE',
                        'BA_DING',
                        'WAWAWAWAA',
                        'JUMP_UP',
                        'JUMP_DOWN',
                        'POWER_UP',
                        'POWER_DOWN',
                        'GE_CHANG_ZU_GUO',
                        'DONG_FANG_HONG',
                        'CAI_YUN_ZHUI_YUE',
                        'ZOU_JIN_XIN_SHI_DAI',
                        'MO_LI_HUA',
                        'YI_MENG_SHAN_XIAO_DIAO'
                    ]
                },
                repeatmode: {
                    acceptReporters: true,
                    items: [
                        {
                            text: '播放一次',
                            value: '1'
                        }, {
                            text: '循环播放',
                            value: '2'
                        }, {
                            text: '在后台播放一次',
                            value: '3'
                        }, {
                            text: '在后台循环播放',
                            value: '4'
                        }
                    ]
                },
                wifiinfo: {
                    acceptReporters: true,
                    items: [
                        {text: 'IP', value: '0'},
                        {text: 'netmask', value: '1'},
                        {text: 'gateway', value: '2'},
                        {text: 'DNS', value: '3'}
                    ]
                },
                wifichannel: {
                    acceptReporters: true,
                    items: [
                        '1',
                        '2',
                        '3',
                        '4',
                        '5',
                        '6',
                        '7',
                        '8',
                        '9',
                        '10',
                        '11',
                        '12',
                        '13'
                    ]
                },
                timezone: {
                    acceptReporters: true,
                    items: [
                        {text: 'UTC+8', value: '8'},
                        {text: 'UTC+9', value: '9'},
                        {text: 'UTC+10', value: '10'},
                        {text: 'UTC+11', value: '11'},
                        {text: 'UTC+12', value: '12'},
                        {text: 'UTC-12', value: '-12'},
                        {text: 'UTC-11', value: '-11'},
                        {text: 'UTC-10', value: '-10'},
                        {text: 'UTC-9', value: '-9'},
                        {text: 'UTC-8', value: '-8'},
                        {text: 'UTC-7', value: '-7'},
                        {text: 'UTC-6', value: '-6'},
                        {text: 'UTC-5', value: '-5'},
                        {text: 'UTC-4', value: '-4'},
                        {text: 'UTC-3', value: '-3'},
                        {text: 'UTC-2', value: '-2'},
                        {text: 'UTC-1', value: '-1'},
                        {text: 'UTC', value: '0'},
                        {text: 'UTC+1', value: '1'},
                        {text: 'UTC+2', value: '2'},
                        {text: 'UTC+3', value: '3'},
                        {text: 'UTC+4', value: '4'},
                        {text: 'UTC+5', value: '5'},
                        {text: 'UTC+6', value: '6'},
                        {text: 'UTC+7', value: '7'}
                    ]
                },
                timeserver: {
                    acceptReporters: true,
                    items: [
                        'time.windows.com',
                        'time.nist.gov',
                        'ntp.ntsc.ac.cn'
                    ]
                },
                thread: {
                    acceptReporters: true,
                    items: ['1', '2', '3', '4']
                },
                mpin: {
                    acceptReporters: true,
                    items: [
                        {text: 'M1', value: 'MOTOR_1'},
                        {text: 'M2', value: 'MOTOR_2'}
                    ]
                },
                mdirection: {
                    acceptReporters: true,
                    items: [
                        {text: '正转', value: '1'},
                        {text: '反转', value: '0'}
                    ]
                },
                dht: {
                    acceptReporters: true,
                    items: [
                        {text: 'DHT11', value: 'DHT11'},
                        {text: 'DHT22', value: 'DHT22'}
                    ]
                },
                dhttype: {
                    acceptReporters: true,
                    items: [
                        {text: '温度', value: 'temperature'},
                        {text: '湿度', value: 'humidity'}
                    ]
                },
                dhtpin: {
                    acceptReporters: true,
                    items: [
                        {text: 'P8', value: '8'},
                        {text: 'P9', value: '9'},
                        {text: 'P13', value: '13'},
                        {text: 'P14', value: '14'},
                        {text: 'P15', value: '15'},
                        {text: 'P16', value: '16'}
                    ]
                },

                neopixelpin: {
                    acceptReporters: true,
                    items: [
                        {text: 'P7(主板)', value: 7},
                        {text: 'P8', value: 8},
                        {text: 'P9(实验箱)', value: 9},
                        {text: 'P13', value: 13},
                        {text: 'P14', value: 14},
                        {text: 'P15', value: 15},
                        {text: 'P16', value: 16}
                    ]
                },
                MQTTtopic: {
                    acceptReporters: true,
                    items: [
                        {text: '主题1', value: '_topic_1'},
                        {text: '主题2', value: '_topic_2'},
                        {text: '主题3', value: '_topic_3'}
                    ]
                },

                image: [
                    {text: '↑', value: '0001100000111100011111101101101100011000000110000001100000011000'},
                    {text: '↓', value: '0001100000011000000110000001100011011011011111100011110000011000'},
                    {text: '←', value: '0001000000110000011000001111111111111111011000000011000000010000'},
                    {text: '→', value: '0000100000001100000001101111111111111111000001100000110000001000'},
                    {text: '♥', value: '0100001011100111111111111111111111111111011111100011110000011000'},
                    {text: '▲', value: '0000000000000000000110000011110001111110111111110000000000000000'},
                    {text: '▼', value: '0000000000000000111111110111111000111100000110000000000000000000'},
                    {text: '◄', value: '0000010000001100000111000011110000111100000111000000110000000100'},
                    {text: '►', value: '0010000000110000001110000011110000111100001110000011000000100000'},
                    {text: '△', value: '0000000000000000000110000010010001000010111111110000000000000000'},
                    {text: '▽', value: '0000000000000000111111110100001000100100000110000000000000000000'},
                    {text: '☺', value: '0011110001000010101001011000000110100101100110010100001000111100'},
                    {text: '○', value: '0011110001000010100000011000000110000001100000010100001000111100'},
                    {text: '◑', value: '0011110001001110100011111000111110001111100011110100111000111100'},
                    {text: '◐', value: '0011110001110010111100011111000111110001111100010111001000111100'},
                    {text: '￥', value: '0100001000100100111111110001000011111111000100000001000000010000'},
                    {text: 'Χ', value: '1000000101000010001001000001100000011000001001000100001010000001'},
                    {text: '√', value: '0000000000000001000000100100010000101000000100000000000000000000'},
                    {text: '□', value: '0000000001111110010000100100001001000010010000100111111000000000'},
                    {text: '▣', value: '0000000001111110010000100101101001011010010000100111111000000000'},
                    {text: '◇', value: '0001100000100100010000101000000110000001010000100010010000011000'},
                    {text: '♀', value: '0001110000100010001000100010001000011100000010000011111000001000'},
                    {text: '♂', value: '0000111100000011000001010111100111011000100010001101100001110000'},
                    {text: '♪', value: '0000110000001110000010110000100000001000011110001111100001100000'},
                    {text: '✈', value: '0010000000110000100110001111111111111111100110000011000000100000'},
                    {text: '卍', value: '1111001000010010000100101111111010010000100100001001111000000000'},
                    {text: '卐', value: '1001111010010000100100001111111000010010000100101111001000000000'},
                    {text: '|', value: '0001000000010000000100000001000000010000000100000001000000010000'},
                    {text: '—', value: '0000000000000000000000000000000011111111000000000000000000000000'},
                    {text: '╱', value: '0000000100000010000001000000100000010000001000000100000010000000'},
                    {text: '＼', value: '1000000001000000001000000001000000001000000001000000001000000001'},
                    {text: '大', value: '0000100000001000011111110000100000001000000101000010001001000001'},
                    {text: '中', value: '0001000000010000111111101001001010010010111111100001000000010000'},
                    {text: '小', value: '0000100000001000000010000010101000101010010010010000100000001110'},
                    {text: '米', value: '1001001001010100001110001111111000111000010101001001001000000000'},
                    {text: '正', value: '1111111100001000000010000100111101001000010010000100100011111111'},
                    {text: '囧', value: '1111111110100101101001011100001110111101101001011010010111111111'}
                ],
                displaytype: {
                    acceptReporters: true,
                    items: [
                        {text: '清空', value: 0},
                        {text: '全亮', value: 1}
                    ]
                },

                SIoTtopic: {
                    acceptReporters: true,
                    items: [
                        {text: '主题1', value: 'topic_1'},
                        {text: '主题2', value: 'topic_2'},
                        {text: '主题3', value: 'topic_3'}
                    ]
                },
                SENIVERSE_CLASSIFY: {
                    acceptReporters: true,
                    items: [
                        '天气',
                        '温度',
                        // '气压',
                        // '湿度',
                        // '风向',
                        // '风力',
                    ]
                },
                SENIVERSE_DAILY_CLASSIFY: {
                    acceptReporters: true,
                    items: [
                        '白天天气',
                        '最高温度',
                        '晚间天气',
                        '最低温度',
                    ]
                },

                MUSIC: {
                    acceptReporters: true,
                    items: this._buildMenu(this.MUSIC_INFO)
                },

                WALLET_CHANGE: {
                    acceptReporters: true,
                    items: [
                        '充值',
                        '扣费'
                    ]
                }
            }
        };
    }

    // noop(){
    //     return Promise.reject(formatMessage({
    //         id: 'kblock.notify.nosupportonlinemode',
    //         defaultMessage: 'Not support in online mode'
    //     }));
    // }
    delayPromise () {
        return new Promise(resolve => {
            let thisInterval = setInterval(() => {
                if (this.running == false) {
                    clearInterval(thisInterval)
                    thisInterval = null
                    resolve();
                }
            }, 16);
        });
    }
    valuePromise (valueStr) {
        return new Promise(resolve => {
            let count = 0
            let thisInterval = setInterval(() => {
                console.log(this[valueStr])
                count++
                if (count >= 20) {
                    clearInterval(thisInterval)
                    thisInterval = null
                    resolve('')
                }
                if (this[valueStr] !== '') {
                    clearInterval(thisInterval)
                    thisInterval = null
                    resolve(this[valueStr])
                }
            }, 100)
        });
    }

    /* 烧录模式特有的方法 */
    // main
    main (args, util) {
        return true
    }
    print (args, util) {
        return args.TEXT
    }
    
    // sensor
    whenPinAction (args, util) {
        switch (String(args.GESTURE)) {
            case 'shaken':
                return this.sensors.gesture == 1;
            case 'jumped':
                return this.sensors.gesture == 2;
            case 'tilted_front':
                return this.sensors.aX < -0.3;
            case 'tilted_back':
                return this.sensors.aX > 0.3;
            case 'tilted_left':
                return this.sensors.aY > 0.3;
            case 'tilted_right':
                return this.sensors.aY < -0.3;
            default:
                return false;
        }
    }
    getTouchKeyValue (args, util) {
        if (this.handpyModal == false) {
            return '请先打开智能开发板'
        }
        // this.handpyWebsiteModal == true
        return this.sensors.touchP
    }
    getSensorValue (args, util) {

        switch (String(args.SENSOR)) {
            case 'light':
                return this.sensors.light;
            case 'sound':
                return this.sensors.sound;
            default:
                return false;
        }

    }
    getAccelerationValue (args, util) {

        switch (String(args.AXIS)) {
            case 'X':
                return toFixed(this.sensors.aX, 4);
            case 'Y':
                return toFixed(this.sensors.aY, 4);
            case 'Z':
                return toFixed(this.sensors.aZ, 4);
            case 'G':
                return toFixed(Math.sqrt(Math.pow(this.sensors.aX, 2) + Math.pow(this.sensors.aY, 2) + Math.pow(this.sensors.aZ, 2)), 4);
            default:
                return false;
        }

    }
    setAccelerationRange (args, util) {

        return false
    }
    getTiltAngle (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        return 0
    }
    getMagneticHeading (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        return 0
    }
    getMagnetic (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        return 0
    }
    getRunningTime (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        return 0
    }
    getTimeDifference (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        return 0
    }
    getLocalTime (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        return 0
    }
    
    // LED
    getLedBrightness (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        return false
    }

    // music
    playMusic (args, util) {
        if (this.handpyModal == false) {
            return '请先打开智能开发板'
        }
        this._playMusicNum(util, args.MUSIC);
    }

    _buildMenu (info) {
        return info.map((entry, index) => {
            const obj = {};
            obj.text = entry.name;
            obj.value = index; // String(index + 1);
            return obj;
        });
    }
    get MUSIC_INFO () {
        return [
            {
                name: '嘀嗒嘀',
                fileName: '嘀嗒嘀'
            }, {
                name: '叮铃铃',
                fileName: '叮铃铃'
            }, {
                name: '呵呵呵',
                fileName: '呵呵呵'
            }, {
                name: '正确',
                fileName: '正确'
            }, {
                name: '水滴',
                fileName: '水滴'
            }, {
                name: '欢呼',
                fileName: '欢呼'
            }, {
                name: '嗯？',
                fileName: '嗯？'
            }
            
        ];
    }

    _loadAllSounds () {
        const loadingPromises = [];
        this.MUSIC_INFO.forEach((musicInfo, index) => {
            const filePath = `music/${musicInfo.fileName}`;
            const promise = this._storeSound(filePath, index, this._musicPlayers);
            loadingPromises.push(promise);
        });

        // this.INSTRUMENT_INFO.forEach((instrumentInfo, instrumentIndex) => {
        //     this._instrumentPlayerArrays[instrumentIndex] = [];
        //     this._instrumentPlayerNoteArrays[instrumentIndex] = [];
        //     instrumentInfo.samples.forEach((sample, noteIndex) => {
        //         const filePath = `instruments/${instrumentInfo.dirName}/${sample}`;
        //         const promise = this._storeSound(filePath, noteIndex, this._instrumentPlayerArrays[instrumentIndex]);
        //         loadingPromises.push(promise);
        //     });
        // });
        // {
        //     name: formatMessage({
        //         id: 'music.instrumentSynthLead',
        //         default: '(20) Synth Lead',
        //         description: 'Sound of a "lead" synthesizer being played'
        //     }),
        //     dirName: '20-synth-lead',
        //     releaseTime: 0.1,
        //     samples: [60]
        // },
        this._instrumentPlayerArrays[0] = [];
        this._instrumentPlayerNoteArrays[0] = [];
        const filePath = `instruments/20-synth-lead/60`;
        const promise = this._storeSound(filePath, 0, this._instrumentPlayerArrays[0]);
        loadingPromises.push(promise);

        Promise.all(loadingPromises).then(() => {
            // @TODO: Update the extension status indicator.
        });
    }
    _storeSound (filePath, index, playerArray) {
        const fullPath = `${filePath}.mp3`;
        if (!assetData[fullPath]) return;
        // The sound player has already been downloaded via the manifest file required above.
        const soundBuffer = assetData[fullPath];
        return this._decodeSound(soundBuffer).then(player => {
            playerArray[index] = player;
        });
    }
    _decodeSound (soundBuffer) {
        const engine = this.runtime.audioEngine;
        if (!engine) {
            return Promise.reject(new Error('No Audio Context Detected'));
        }
        // Check for newer promise-based API
        return engine.decodeSoundPlayer({data: {buffer: soundBuffer}});
    }

    _playMusicNum (util, musicNum) {
        if (util.runtime.audioEngine === null) return;
        if (util.target.sprite.soundBank === null) return;
        // If we're playing too many sounds, do not play the drum sound.
        if (this._concurrencyCounter > 30) {
            return;
        }

        const player = this._musicPlayers[musicNum];

        if (typeof player === 'undefined') return;

        if (player.isPlaying && !player.isStarting) {
            player.take();
        }

        const engine = util.runtime.audioEngine;
        const context = engine.audioContext;
        const volumeGain = context.createGain();
        volumeGain.gain.setValueAtTime(util.target.volume / 100, engine.currentTime);
        volumeGain.connect(engine.getInputNode());

        this._concurrencyCounter++;
        player.once('stop', () => {
            this._concurrencyCounter--;
        });

        player.play();
        // Connect the player to the gain node.
        player.connect({getInputNode () {
            return volumeGain;
        }});
    }
    
    // radio
    whenRadioRecvMessage (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        return false
    }
    getRadioMessage (args, util) {
        
        return this.sensors.msgRadio
    }

    // show
    oledShow (args, util) {
        if (this.handpyModal == false) {
            return '请先打开智能开发板'
        }
        // this.handpyWebsiteModal == true
        // this.oledShowStatus = true
        this.runtime.emit('HANDPY_VIRTUAL', {type: `oledDisplayShow`, data: true});
        return
    }
    oledProgressBar (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        return false
    }

    // Wi-Fi
    connectWifi (args, util) {
        if (this.handpyModal == false) {
            return '请先打开智能开发板'
        }
        // this.handpyWebsiteModal == true
        if (this.wifi.ssid == args.SSID && this.wifi.password == args.PASSWORD) {
            this.wifi.status = '已连接'
        } else {
            this.wifi.status = '未连接'
        }
        return
    }
    hasConnectedWifi (args, util) {
        if (this.handpyModal == false) {
            return '请先打开智能开发板'
        }
        // this.handpyWebsiteModal == true
        return this.wifi.status == '已连接'
    }
    getWifiInfo (args, util) {
        if (this.handpyModal == false) {
            return '请先打开智能开发板'
        }
        if (this.wifi.status == '未连接') {
            return '请先连接Wi-Fi'
        }

        return this.wifi.ip
    }
    disconnectWifi (args, util) {
        if (this.handpyModal == false) {
            return '请先打开智能开发板'
        }
        // this.handpyWebsiteModal == true
        this.wifi.status = '未连接'
        return
    }
    enableAPMode (args, util) {
        return this.wifi
    }
    disableAPMode (args, util) {
        return this.wifi
    }
    syncNetTime (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        return false
    }

    // Speech
    speechRecognition (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        return false
    }
    getSpeechText (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        return false
    }
    isSpeechContains (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        return false
    }

    // Thread
    defineThread (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        return false
    }
    runThread (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        return false
    }

    // extension
    motorRun (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        return false
    }
    motorStop (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        return false
    }
    motorSpeed (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        return false
    }
    dhtValue (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        return false
    }
    hcsr04Value (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        return false
    }


    displayMatrix (args, util) {
        if (this.runMode != 1) {
            return 
        }
        return false
    }
    displayImage (args, util) {
        if (this.runMode != 1) {
            return 
        }
        return false
    }
    displayBrightness (args, util) {
        if (this.runMode != 1) {
            return 
        }
        return false
    }
    displayType (args, util) {
        if (this.runMode != 1) {
            return 
        }
        return false
    }

    neopixel_init (args, util) {
        if (this.runMode != 1) {
            return 
        }
        return false
    }
    neopixel_set_color (args, util) {
        if (this.runMode != 1) {
            return 
        }
        return false
    }
    neopixel_set_color_num (args, util) {
        if (this.runMode != 1) {
            return 
        }
        return false
    }
    neopixel_set_all_color (args, util) {
        if (this.runMode != 1) {
            return 
        }
        return false
    }
    neopixel_set_all_color_num (args, util) {
        if (this.runMode != 1) {
            return 
        }
        return false
    }
    neopixel_take_effect (args, util) {
        if (this.runMode != 1) {
            return 
        }
        return false
    }
    neopixel_all_off (args, util) {
        if (this.runMode != 1) {
            return 
        }
        return false
    }
    neopixel_set_brightness (args, util) {
        if (this.runMode != 1) {
            return 
        }
        return false
    }
    neopixel_make_rainbow (args, util) {
        if (this.runMode != 1) {
            return 
        }
        return false
    }

    // SIoT
    connectSIoT (args, util) {
        if (this.handpyModal == false) {
            return '请先打开智能开发板'
        }
        // this.handpyWebsiteModal == true
        if (this.wifi.status == '未连接') {
            return '没有连接wifi'
        }
        if (this.siot.ID == args.ID && this.siot.SERVER == args.SERVER && this.siot.USER == args.USER && this.siot.PASSWORD == args.PASSWORD) {
            this.siot.status = 'SIoT连接成功'
        } else {
            this.siot.status = 'SIoT未连接'
        }
        return
    }
    SIoTStatus (args, util) {
        if (this.handpyModal == false) {
            return '请先打开智能开发板'
        }
        // this.handpyWebsiteModal == true
        return this.siot.status
    }
    hasConnectedSIoT (args, util) {
        if (this.handpyModal == false) {
            return '请先打开智能开发板'
        }
        // this.handpyWebsiteModal == true
        return this.siot.status == 'SIoT连接成功'
    }
    subscribeSIot (args, util) {
        if (this.handpyModal == false) {
            return '请先打开智能开发板'
        }
        // this.handpyWebsiteModal == true
        if (this.siot.status == 'SIoT连接成功') {
            this.siot[args.TOPIC] = args.TOPICNAME
            this.runtime.emit('HANDPY_VIRTUAL', {
                type: `subscribeSIot`,
                data: {
                    topic: args.TOPIC,
                    topicname: args.TOPICNAME
                }
            });
        } else {
            return 'SIoT未连接'
        }
    }
    publishSIoT (args, util) {
        if (this.siot.status == 'SIoT连接成功') {
            // args.MESSAGE
            if (args.MESSAGE !== '') {
                this.runtime.emit('HANDPY_VIRTUAL', {
                    type: `publishSIoT`,
                    data: {
                        topic: args.TOPIC,
                        message: args.MESSAGE
                    }
                });
            }
            
        } else {
            return 'SIoT未连接'
        }
    }

    // BLE UART
    createBLE (args, util) {
        if (this.handpyModal == false) {
            return '请先打开智能开发板'
        }
        // updateHandpyMobileModalBleName
        this.ble.status = 'BLE UART 已连接'
        this.runtime.emit('HANDPY_VIRTUAL', {
            type: `updateHandpyMobileModalBleName`,
            data: args.BLENAME
        });
    }
    whenBLERecieveMsg (args, util) {
        if (this.handpyModal == false) {
            return false
        }
        // console.log('this.ble.msg, ', this.ble.msg)
        return this.ble.msg !== ''
    }
    BLEMsg (args, util) {
        if (this.handpyModal == false) {
            return ''
        }
        return this.ble.msg
    }
    BLESendMsg (args, util) {
        if (this.handpyModal == false) {
            return '请先打开智能开发板'
        }
        if (args.MSG) {
            this.runtime.emit('HANDPY_VIRTUAL', {
                type: `updateHandpyMobileModalBleMsg`,
                data: args.MSG
            });
        }
        
    }

    // I2C射频卡
    initDigitalWallet (args, util) {
        if (this.handpyModal == false) {
            return '请先打开智能开发板'
        }
        if (!this.digitalWallet.ble) {
            return '未碰触BLE UART'
        }
        if (this.digitalWallet.status == '未开启') {
            return '未扫描'
        }
        this.digitalWallet.balance = 0
    }
    I2CScan (args, util) {
        if (this.handpyModal == false) {
            return '请先打开智能开发板'
        }
        this.digitalWallet.status = '已开启'
    }
    I2CScanData (args, util) {
        if (this.handpyModal == false) {
            return false
            // return '请先打开智能开发板'
        }
        if (!this.digitalWallet.ble) {
            return false
            // return '未碰触BLE UART'
        }
        if (this.digitalWallet.status == '未开启') {
            return false
            // return '未扫描'
        }
        return true
    }
    I2CTouchBLE (args, util) {
        this.digitalWallet.ble = true
    }
    I2CLeaveBLE (args, util) {
        this.digitalWallet.ble = false
    }
    I2CChangeDigitalWallet (args, util) {
        if (this.handpyModal == false) {
            return '请先打开智能开发板'
        }
        if (!this.digitalWallet.ble) {
            return '未碰触BLE UART'
        }
        if (this.digitalWallet.status == '未开启') {
            return '未扫描'
        }

        if (args.BALANCE == '') {
            return false
        }
        if (isNaN(parseInt(args.BALANCE))) {
            return false
        }
        if (args.CHANGE == '充值') {
            this.digitalWallet.balance += parseInt(args.BALANCE)
        }
        if (args.CHANGE == '扣费') {
            this.digitalWallet.balance -= parseInt(args.BALANCE)
        }
    }
    I2CWalletBalance (args, util) {
        if (this.handpyModal == false) {
            return '请先打开智能开发板'
        }
        if (!this.digitalWallet.ble) {
            return '未碰触BLE UART'
        }
        if (this.digitalWallet.status == '未开启') {
            return '未扫描'
        }

        return this.digitalWallet.balance
    }

    // MQTT
    connectMQTT (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        return false
    }
    hasConnectedMQTT (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        return false
    }
    subscribeMQTT (args, util) {
        if (this.runMode != 1) {
            console.log('烧录模式无法执行交互')
            return
        }
        return false
    }
    disconnectMQTT (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        return false
    }
    publishMQTT (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        return false
    }
    messageMQTT (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        return false
    }
    receiveMQTT (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        return false
    }

    
    /* 交互模式的方法 */
    // sensor
    getLightValue (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        return this.sensors.light;
    }
    getSoundValue (args, util) {

        if (this.handpyModal == false) {
            return '请先打开智能开发板'
        }
        // this.handpyWebsiteModal == true

        if (typeof this.runtime.audioEngine === 'undefined') return -1;
        if (this.runtime.currentStepTime === null) return -1;

        // Only measure loudness once per step
        const timeSinceLoudness = this._timer.time() - this._cachedLoudnessTimestamp;
        if (timeSinceLoudness < this.runtime.currentStepTime) {
            return this._cachedLoudness;
        }

        this._cachedLoudnessTimestamp = this._timer.time();
        this._cachedLoudness = this.runtime.audioEngine.getLoudness();

        this.sensors.sound = this._cachedLoudness;
        if (this._cachedLoudness == -1) {
            this._cachedLoudnessErrCount++;
            if (this._cachedLoudnessErrCount == 10) {
                this.runtime.emit('HANDPY_VIRTUAL', {
                    type: `showAlertWithAixiong`,
                    data: {
                        maxDisplaySecs: 5,
                        closeButton: true,
                        content: '当前噪声值一直是-1，请检查电脑麦克风使用是否正确',
                        iconURL: miniIconURI
                        // iconSpinner: true
                    }
                });
                this._cachedLoudnessErrCount = 0;
            }
        } else {
            this._cachedLoudnessErrCount = 0;
        }
        if (this._cachedLoudness == 0) {
            this._cachedLoudness0Count++;
            if (this._cachedLoudness0Count == 10) {
                this.runtime.emit('HANDPY_VIRTUAL', {
                    type: `showAlertWithAixiong`,
                    data: {
                        maxDisplaySecs: 5,
                        closeButton: true,
                        content: '当前噪声值一直是0，请检查电脑麦克风使用是否正确',
                        iconURL: miniIconURI
                        // iconSpinner: true
                    }
                });
                this._cachedLoudness0Count = 0;
            }
        } else {
            this._cachedLoudness0Count = 0;
        }
        
        return this.sensors.sound;
    }
    getExtValue (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        return this.sensors.ext;
    }
    getAxValue (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        return toFixed(this.sensors.aX, 4);
    }
    getAyValue (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        return toFixed(this.sensors.aY, 4);
    }
    getAzValue (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        return toFixed(this.sensors.aZ, 4);
    }
    getAgValue (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        return toFixed(Math.sqrt(Math.pow(this.sensors.aX, 2) + Math.pow(this.sensors.aY, 2) + Math.pow(this.sensors.aZ, 2)), 4);
    }

    isButtonPressed (args, util) {
        if (this.handpyModal == false) {
            return '请先打开智能开发板'
        }
        // this.handpyWebsiteModal == true
        switch (String(args.BTN)) {
            case 'A':
                return this.sensors.buttonA !== 0;
            case 'B':
                return this.sensors.buttonB !== 0;
            case 'P':
                return this.sensors.touchP !== 0;
            case 'Y':
                return this.sensors.touchY !== 0;
            case 'T':
                return this.sensors.touchT !== 0;
            case 'H':
                return this.sensors.touchH !== 0;
            case 'O':
                return this.sensors.touchO !== 0;
            case 'N':
                return this.sensors.touchN !== 0;
            default:
                return false;
        }
    }

    isGesture (args, util) {
        switch (String(args.GESTURE)) {
            case 'shaken':
                return this.sensors.gesture == 1;
            case 'jumped':
                return this.sensors.gesture == 2;
            case 'tilted_front':
                return this.sensors.aX < -0.3;
            case 'tilted_back':
                return this.sensors.aX > 0.3;
            case 'tilted_left':
                return this.sensors.aY > 0.3;
            case 'tilted_right':
                return this.sensors.aY < -0.3;
            default:
                return false;
        }
    }

    getTiltAngle2 (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        let tilted = String(args.TILTED)
        let aX = this.args.aX
        let aY = this.args.aY
        let aZ = this.args.aZ
        let A = 0
        switch (tilted) {
            case 'tilted_front':
                return (
                    (A = Math.sqrt(aY * aY + aZ * aZ)),
                    (-1 * Math.atan2(aX, A) * 180) /
                        Math.PI
                );
            case 'tilted_back':
                return (
                    (A = Math.sqrt(aY * aY + aZ * aZ)),
                    (180 * Math.atan2(aX, A)) / Math.PI
                );
            case 'tilted_left':
                return (
                    (A = Math.sqrt(aX * aX + aZ * aZ)),
                    (-1 * Math.atan2(aY, A) * 180) /
                        Math.PI
                );
            case 'tilted_right':
                return (
                    (A = Math.sqrt(aX * aX + aZ * aZ)),
                    (180 * Math.atan2(aY, A)) / Math.PI
                );
            default:
                return 0;
        }
    }

    // event
    whenButtonPressed (args, util) {
        if (this.handpyModal == false) {
            return false
        }
        // this.handpyWebsiteModal == true
        switch (String(args.BTN)) {
            case 'A':
                return args.ACTION == 'pressed' ?
                    !!this.sensors.buttonA :
                    !this.sensors.buttonA;
            case 'B':
                return args.ACTION == 'pressed' ?
                    !!this.sensors.buttonB :
                    !this.sensors.buttonB;
            case 'P':
                return args.ACTION == 'pressed' ?
                    !!this.sensors.touchP :
                    !this.sensors.touchP;
            case 'Y':
                return args.ACTION == 'pressed' ?
                    !!this.sensors.touchY :
                    !this.sensors.touchY;
            case 'T':
                return args.ACTION == 'pressed' ?
                    !!this.sensors.touchT :
                    !this.sensors.touchT;
            case 'H':
                return args.ACTION == 'pressed' ?
                    !!this.sensors.touchH :
                    !this.sensors.touchH;
            case 'O':
                return args.ACTION == 'pressed' ?
                    !!this.sensors.touchO :
                    !this.sensors.touchO;
            case 'N':
                return args.ACTION == 'pressed' ?
                    !!this.sensors.touchN :
                    !this.sensors.touchN;
            default:
                return false;
        }
    }
    whenGesture (args, util) {
        switch (String(args.GESTURE)) {
            case 'shaken':
                return this.sensors.gesture == 1;
            case 'jumped':
                return this.sensors.gesture == 2;
            case 'tilted_front':
                return this.sensors.aX < -0.3;
            case 'tilted_back':
                return this.sensors.aX > 0.3;
            case 'tilted_left':
                return this.sensors.aY > 0.3;
            case 'tilted_right':
                return this.sensors.aY < -0.3;
            default:
                return false;
        }
    }

    // LED
    setRGBColor (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        let rgb = String(args.RGB)
        let color = String(args.COLOR);
        if (color.length != 7) {
            return false
        }
        let r_s = color.substring(1, 3)
        let g_s = color.substring(3, 5)
        let b_s = color.substring(5, 7)
        let r = parseInt((parseInt(r_s, 16) * this.brightness) / 9)
        let g = parseInt((parseInt(g_s, 16) * this.brightness) / 9)
        let b = parseInt((parseInt(b_s, 16) * this.brightness) / 9)
        let code = ''

        switch (rgb) {
            case '0':
                code = `rgb[0]=(${r},${g},${b});rgb.write();time.sleep_ms(1)\r\n`
                break;
            case '1':
                code = `rgb[1]=(${r},${g},${b});rgb.write();time.sleep_ms(1)\r\n`
                break;
            case '2':
                code = `rgb[2]=(${r},${g},${b});rgb.write();time.sleep_ms(1)\r\n`
                break;
            default:
                code = `rgb.fill((${r},${g},${b}));rgb.write();time.sleep_ms(1)\r\n`
        }

        if (util.stackTimerNeedsInit()) {
            util.startStackTimer(100);
            this.runcode(code)
            util.yield();
        } else if (!util.stackTimerFinished()) {
            util.yield();
        }
    }
    setRGBColorNum (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        let rgb = String(args.RGB)
        let r = parseInt((toNumber(args.R) * this.brightness) / 9)
        let g = parseInt((toNumber(args.G) * this.brightness) / 9)
        let b = parseInt((toNumber(args.B) * this.brightness) / 9)
        let code = ''
        switch (rgb) {
            case '0':
                code = `rgb[0]=(${r},${g},${b});rgb.write();time.sleep_ms(1)\r\n`
                break;
            case '1':
                code = `rgb[1]=(${r},${g},${b});rgb.write();time.sleep_ms(1)\r\n`
                break;
            case '2':
                code = `rgb[2]=(${r},${g},${b});rgb.write();time.sleep_ms(1)\r\n`
                break;
            default:
                code = `rgb.fill((${r},${g},${b}));rgb.write();time.sleep_ms(1)\r\n`
        }

        if (util.stackTimerNeedsInit()) {
            util.startStackTimer(100);
            this.runcode(code)
            util.yield();
        } else if (!util.stackTimerFinished()) {
            util.yield();
        }
    }
    turnOffRGB (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        let code = ''
        switch (String(args.RGB)) {
            case '0':
                code = `rgb[0]=(0,0,0);rgb.write();time.sleep_ms(1)\r\n`
                break;
            case '1':
                code = `rgb[1]=(0,0,0);rgb.write();time.sleep_ms(1)\r\n`
                break;
            case '2':
                code = `rgb[2]=(0,0,0);rgb.write();time.sleep_ms(1)\r\n`
                break;
            default:
                code = `rgb.fill((0,0,0));rgb.write();time.sleep_ms(1)\r\n`
        }

        if (util.stackTimerNeedsInit()) {
            util.startStackTimer(100);
            this.runcode(code)
            util.yield();
        } else if (!util.stackTimerFinished()) {
            util.yield();
        }
    }
    setLedBrightness (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        let brightness = parseInt(toNumber(args.BRIGHTNESS))
        this.brightness = brightness
    }
    getLedBrightness2 (args) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        return this.brightness
    }

    // music
    stopMusic (args, util) {
        if (this.handpyModal == false) {
            return '请先打开智能开发板'
        }
        // console.log(this._musicPlayers)
        this._musicPlayers.map(player => {
            // console.log(player)
            if (player.isPlaying) {
                console.log(player)
                if (player.outputNode) {
                    player.outputNode.stop()
                }
                player.stop();
            }
            
        })

        this._instrumentPlayerNoteArrays.map(ins => {
            ins.map(player => {
                if (player.isPlaying) {
                    // console.log(player)
                    if (player.outputNode) {
                        player.outputNode.stop()
                    }
                    player.stop();
                }
            })
        })
        
        // if (util.stackTimerNeedsInit()) {
        //     util.startStackTimer(1);
        //     util.yield();
        // } else if (!util.stackTimerFinished()) {
        //     util.yield();
        // }
    }
    // 持续演奏音符
    playTone (args, util) {
        if (this.handpyModal == false) {
            return '请先打开智能开发板'
        }
        
        let tone = parseInt(toNumber(args.TONE))
        tone = MathUtil.clamp(tone, 0, 130);

        this._playNote(util, tone)     
    }
    // 演奏x音符y秒
    playToneFor (args, util) {
        if (this.handpyModal == false) {
            return '请先打开智能开发板'
        }
        
        let tone = parseInt(toNumber(args.TONE))
        tone = MathUtil.clamp(tone, 0, 130);

        let duration = parseInt(1000 * toNumber(args.DURATION))

        return this._playNote(util, tone, duration / 1000)      
    }
    // 演奏x音符y秒
    playNote (args, util) {
        if (this.handpyModal == false) {
            return '请先打开智能开发板'
        }

        let tone = parseInt(toNumber(args.TONE))
        tone = MathUtil.clamp(tone, 0, 130);
        let beat = parseInt(this.ticks * toNumber(args.BEAT))
        let bt = parseInt(beat * this.bpmTime);
        tone += this.musicOctave
        let note = notes[tone][0]
        
        if (note != 'C0') {
            this.runtime.requestRedraw();
            return this._playNote(util, tone, bt / 1000)
        }        
    }
    playEmptyNote (args, util) {
        if (this.handpyModal == false) {
            return '请先打开智能开发板'
        }

        let beat = parseInt(this.ticks * toNumber(args.BEAT))
        let bt = parseInt(beat * this.bpmTime)
        
        if (util.stackTimerNeedsInit()) {
            util.startStackTimer(bt);
            util.yield();
        } else if (!util.stackTimerFinished()) {
            util.yield();
        }
    }

    _playNote (util, note, durationSec = 5) {
        if (util.runtime.audioEngine === null) return;
        if (util.target.sprite.soundBank === null) return;

        if (this._concurrencyCounter > 30) {
            return;
        }

        // const musicState = this._getMusicState(util.target);
        // const inst = musicState.currentInstrument;
        // const instrumentInfo = this.INSTRUMENT_INFO[inst];
        // const sampleArray = instrumentInfo.samples;
        // const sampleIndex = this._selectSampleIndexForNote(note, sampleArray);
        const inst = 0;
        const sampleArray = [60];
        const sampleIndex = this._selectSampleIndexForNote(note, sampleArray);

        if (typeof this._instrumentPlayerArrays[inst] === 'undefined') return;
        if (typeof this._instrumentPlayerArrays[inst][sampleIndex] === 'undefined') return;

        const engine = util.runtime.audioEngine;

        if (!this._instrumentPlayerNoteArrays[inst][note]) {
            this._instrumentPlayerNoteArrays[inst][note] = this._instrumentPlayerArrays[inst][sampleIndex].take();
        }

        const player = this._instrumentPlayerNoteArrays[inst][note];

        if (player.isPlaying && !player.isStarting) {
            player.take();
        }

        const sampleNote = sampleArray[sampleIndex];
        const notePitchInterval = this._ratioForPitchInterval(note - sampleNote);

        const context = engine.audioContext;
        const volumeGain = context.createGain();
        volumeGain.gain.setValueAtTime(util.target.volume / 100, engine.currentTime);
        const releaseGain = context.createGain();
        volumeGain.connect(releaseGain);
        releaseGain.connect(engine.getInputNode());

        // Schedule the release of the note, ramping its gain down to zero,
        // and then stopping the sound.
        // let releaseDuration = this.INSTRUMENT_INFO[inst].releaseTime;
        // if (typeof releaseDuration === 'undefined') {
        //     releaseDuration = 0.01;
        // }
        let releaseDuration = 0.1;

        const releaseStart = context.currentTime + durationSec;
        const releaseEnd = releaseStart + releaseDuration;
        releaseGain.gain.setValueAtTime(1, releaseStart);
        releaseGain.gain.linearRampToValueAtTime(0.0001, releaseEnd);

        if (durationSec) {
            return new Promise((ret, rej) => {
                
                this._concurrencyCounter++;
                player.once('stop', () => {
                    // console.log('stoped')
                    ret()
                    this._concurrencyCounter--;
                });

                player.play();
                player.connect({getInputNode () {
                    return volumeGain;
                }});
                player.outputNode.playbackRate.value = notePitchInterval;
                player.outputNode.stop(releaseEnd);
            })
            
        }
        
    }
    _selectSampleIndexForNote (note, samples) {
        for (let i = samples.length - 1; i >= 0; i--) {
            if (note >= samples[i]) {
                return i;
            }
        }
        return 0;
    }
    _ratioForPitchInterval (interval) {
        return Math.pow(2, (interval / 12));
    }



    setMusicTempo (args, util) {
        if (this.handpyModal == false) {
            return '请先打开智能开发板'
        }
        let ticks = parseInt(toNumber(args.TICKS)) / 4
        let bpm = parseInt(toNumber(args.BPM))
        this.ticks = ticks
        this.bpmTime = parseInt(60000 / (ticks * bpm))
    }
    setMusicOctave (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        let octave = parseInt(toNumber(args.OCTAVE))
        this.musicOctave = octave
    }
    setMusicOutput (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        let PORT = parseInt(toNumber(args.PORT))
        this.musicOutput = PORT
    }
    
    // radio
    turnRadioOn (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        let channel = parseInt(toNumber(args.CHANNEL))
        if (channel < 1 || channel > 13) {
            return false
        }
        let code = `radio.on()\r\nradio.config(channel=${channel})\r\n`
        if (util.stackTimerNeedsInit()) {
            util.startStackTimer(1);
            this.runcode(code)
            util.yield()
        } else if (!util.stackTimerFinished()) {
            util.yield()
        }
    }
    turnRadioOff (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        if (util.stackTimerNeedsInit()) {
            util.startStackTimer(1);
            this.runcode('radio.off()\r\n')
            util.yield()
        } else if (!util.stackTimerFinished()) {
            util.yield()
        }
    }
    sendRadioMessage (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        let message = String(args.MESSAGE)
        let code = `radio.send('${toUnicode(message)}')\r\n`
        if (util.stackTimerNeedsInit()) {
            util.startStackTimer(1);
            this.runcode(code)
            util.yield()
        } else if (!util.stackTimerFinished()) {
            util.yield()
        }
    }
    whenRadioRecv (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        return this.sensors.msgRadio !== ''
    }


    // show
    oledClear (args, util) {
        if (this.handpyModal == false) {
            return '请先打开智能开发板'
        }
        // this.handpyWebsiteModal == true
        this.runtime.emit('HANDPY_VIRTUAL', {type: `oledDisplayByLine1`, data: ''});
        this.runtime.emit('HANDPY_VIRTUAL', {type: `oledDisplayByLine2`, data: ''});
        this.runtime.emit('HANDPY_VIRTUAL', {type: `oledDisplayByLine3`, data: ''});
        this.runtime.emit('HANDPY_VIRTUAL', {type: `oledDisplayByLine4`, data: ''});
    }
    oledDisplayByLine (args, util) {
        if (this.handpyModal == false) {
            return '请先打开智能开发板'
        }
        // this.handpyWebsiteModal == true
        let line = parseInt(toNumber(args.LINE))
        if (line < 1 || line > 4) {
            return false
        }
        this.runtime.emit('HANDPY_VIRTUAL', {type: `oledDisplayByLine${line}`, data: args.TEXT});

    }
    oledClearByLine (args, util) {
        if (this.handpyModal == false) {
            return '请先打开智能开发板'
        }
        // this.handpyWebsiteModal == true
        let line = parseInt(toNumber(args.LINE))
        if (line < 1 || line > 4) {
            return false
        }
        this.runtime.emit('HANDPY_VIRTUAL', {type: `oledDisplayByLine${line}`, data: ''});
    }
    oledDisplayText (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        let text = String(args.TEXT)
        let x = toNumber(args.X)
        let y = toNumber(args.Y)
        let code = `oled.DispChar('${toUnicode(text)}', ${x}, ${y}, 1); oled.show()\r\n`

        if (util.stackTimerNeedsInit()) {
            util.startStackTimer(1);
            this.runcode(code)
            util.yield()
        } else if (!util.stackTimerFinished()) {
            util.yield()
        }
    }
    oledDrawPoint (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        let pointmode = String(args.POINTMODE)
        let code = `oled.pixel('${parseInt(toNumber(args.X))}', ${parseInt(toNumber(args.Y))}, ${pointmode}); oled.show()\r\n`

        if (util.stackTimerNeedsInit()) {
            util.startStackTimer(1);
            this.runcode(code)
            util.yield()
        } else if (!util.stackTimerFinished()) {
            util.yield()
        }
    }
    oledDrawLine (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }

        let drawmethod = String(args.DRAWMETHOD)
        let code = `oled.line(${parseInt(toNumber(args.X1))}, ${parseInt(toNumber(args.Y1))}, ${parseInt(toNumber(args.X2))}, ${parseInt(toNumber(args.Y2))}, ${drawmethod});oled.show()\r\n`

        if (util.stackTimerNeedsInit()) {
            util.startStackTimer(1);
            this.runcode(code)
            util.yield()
        } else if (!util.stackTimerFinished()) {
            util.yield()
        }
    }
    oledDrawVHLine (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }

        let drawmethod = String(args.DRAWMETHOD)
        let drawdirection = String(args.DRAWDIRECTION)
        let code = `oled.${drawdirection == '0' ? 'vline' : 'hline'}(${parseInt(toNumber(args.X))}, ${parseInt(toNumber(args.Y))}, ${parseInt(toNumber(args.LEN))}, ${drawmethod});oled.show()\r\n`

        if (util.stackTimerNeedsInit()) {
            util.startStackTimer(1);
            this.runcode(code)
            util.yield()
        } else if (!util.stackTimerFinished()) {
            util.yield()
        }
    }
    oledDrawRectangle (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }

        let drawmethod = String(args.DRAWMETHOD)
        let fillmode = String(args.FILLMODE)

        if (fillmode == '_') {
            fillmode = ''
        }

        let code = `oled.${fillmode}rect(${parseInt(toNumber(args.X))}, ${parseInt(toNumber(args.Y))}, ${parseInt(toNumber(args.W))}, ${parseInt(toNumber(args.H))}, ${drawmethod});oled.show()\r\n`

        if (util.stackTimerNeedsInit()) {
            util.startStackTimer(1);
            this.runcode(code)
            util.yield()
        } else if (!util.stackTimerFinished()) {
            util.yield()
        }
    }
    oledDrawCircle (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        let drawmethod = String(args.DRAWMETHOD)
        let fillmode = String(args.FILLMODE)

        if (fillmode == '_') {
            fillmode = ''
        }

        let code = `oled.${fillmode}circle(${parseInt(toNumber(args.X))}, ${parseInt(toNumber(args.Y))}, ${parseInt(toNumber(args.R))}, ${drawmethod});oled.show()\r\n`

        if (util.stackTimerNeedsInit()) {
            util.startStackTimer(1);
            this.runcode(code)
            util.yield()
        } else if (!util.stackTimerFinished()) {
            util.yield()
        }
    }
    oledDrawTriangle (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }

        let drawmethod = String(args.DRAWMETHOD)
        let fillmode = String(args.FILLMODE)

        if (fillmode == '_') {
            fillmode = ''
        }

        let code = `oled.${fillmode}triangle(${parseInt(toNumber(args.X1))}, ${parseInt(toNumber(args.Y1))}, ${parseInt(toNumber(args.X2))}, ${parseInt(toNumber(args.Y2))}, ${parseInt(toNumber(args.X3))}, ${parseInt(toNumber(args.Y3))}, ${drawmethod});oled.show()\r\n`

        if (util.stackTimerNeedsInit()) {
            util.startStackTimer(1);
            this.runcode(code)
            util.yield()
        } else if (!util.stackTimerFinished()) {
            util.yield()
        }
    }
    oledDisplayImage (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }

        let code = `display_pbm_data(get_pbm_data(${String(args.IMAGE)}), ${parseInt(toNumber(args.X))}, ${parseInt(toNumber(args.Y))});oled.show()\r\n`

        if (util.stackTimerNeedsInit()) {
            util.startStackTimer(5);
            this.runcode(code)
            util.yield()
        } else if (!util.stackTimerFinished()) {
            util.yield()
        }
    }
    oledDisplayLocalImage (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        let image = String(args.IMAGE)
        let img = {}
        let hexData = ''
        let imgWidth = 0
        let imgHeight = 0
        try {
            img = JSON.parse(image)
            // hexData = img.imgSrc
            imgWidth = img.imgWidth
            imgHeight = img.imgHeight
            hexData = img.hexData
        } catch (e) {
            return;
        }

        let code = `oled.Bitmap(${parseInt(toNumber(args.X))}, ${parseInt(toNumber(args.Y))},bytearray([${hexData}]), ${imgWidth}, ${imgHeight}, 1); oled.show()\r\n`
        
        if (util.stackTimerNeedsInit()) {
            setTimeout(() => {
                this.runcode(code)
                util.yield()
            }, 200)
            util.startStackTimer(300)
        } else if (!util.stackTimerFinished()) {
            util.yield()
        }
        
    }

    // Pin
    getPinDigitalValue (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        let pin = parseInt(toNumber(args.PIN))
        let code = `_pind[${pin}]=1`
        if (this.sensors.monitor.indexOf(code) == -1) {
            this.sensors.monitor.push(code)
        }
        return this.sensors.pinDigital[pin]

    }
    setPinDigitalValue (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }

        let code = `MPythonPin(${parseInt(toNumber(args.PIN))}, PinMode.OUT).write_digital(${parseInt(toNumber(args.STATE))})\r\n`
        if (util.stackTimerNeedsInit()) {
            util.startStackTimer(1);
            this.runcode(code)
            util.yield()
        } else if (!util.stackTimerFinished()) {
            util.yield()
        }
    }
    getPinAnalogValue (args, util) {
        if (this.handpyModal == false) {
            return '请先打开智能开发板'
        }

        let pin = parseInt(toNumber(args.PIN))
        return this.sensors.pinAnalog[pin]
    }
    setPinAnalogValue (args, util) {
        if (this.runMode != 1) {
            // console.log('烧录模式无法执行交互')
            return
        }
        let code = `MPythonPin(${parseInt(toNumber(args.PIN))}, PinMode.PWM).write_analog(${parseInt(toNumber(args.VALUE))})\r\n`
        
        if (util.stackTimerNeedsInit()) {
            util.startStackTimer(16);
            this.runcode(code)
            util.yield()
        } else if (!util.stackTimerFinished()) {
            util.yield()
        }
    }
    setPinServoAngle (args, util) {
        if (this.handpyModal == false) {
            return '请先打开智能开发板'
        }

        let pin = parseInt(toNumber(args.PIN))
        this.sensors.pinAnalog[pin] = args.ANGLE
    }


    // seniverse
    seniverse_search (args, utils) {

        if (this.wifi.status == '未连接') {
            return '没有连接wifi'
        }
        // this.wifi.status = '未连接'

        let {APIKEY, LOCATION, CLASSIFY} = args
        let classifyMap = {
            天气: 'text',
            温度: 'temperature',
            气压: 'pressure',
            湿度: 'humidity',
            风向: 'wind_direction',
            风力: 'wind_scale',
        }

        if (this.seniverseData.lastresult_search == LOCATION && (new Date().getTime()) < (this.seniverseData.lastresultDate + (30 * 60 * 1000))) {
            if (this.seniverseData.now) {
                if (this.seniverseData.now[classifyMap[CLASSIFY]] !== '') {
                    return this.seniverseData.now[classifyMap[CLASSIFY]]
                }
            }
        }
        // localStorage.getItem(keyword)
        // localStorage.setItem(keyword, `${value}`)

        // https://api.seniverse.com/v3/weather/now.json?key=your_api_key&location=beijing&language=zh-Hans&unit=c
        const url = `https://api.seniverse.com/v3/weather/now.json?key=${APIKEY}&location=${LOCATION}`;

        let resJson = {
        }
        return new Promise((resolve, reject) => {
            fetch(url, {
                method: 'GET',
                headers: {
                    // 'content-type': 'application/json'
                },
                // body: JSON.stringify(resJson)

            }).then(res => res.json()).then(ret => {
                
                if (ret.results && ret.results[0]) {
                    this.seniverseData = {
                        lastresult_search: LOCATION,
                        lastresult: ret.results[0],
                        lastresultDate: new Date().getTime(),
                        location: ret.results[0].location,
                        now: ret.results[0].now
                    }
                    resolve(ret.results[0].now[classifyMap[CLASSIFY]]);
                } else {
                    this.seniverseData = {
                        lastresult_search: LOCATION,
                        lastresult: '',
                        lastresultDate: new Date().getTime(),
                        location: '',
                        now: {
                            text: '',
                            temperature: '',
                            pressure: '',
                            humidity: '',
                            wind_direction: '',
                            wind_scale: ''
                        }
                    }
                    if (ret.status == 'The location can not be found.') {
                        this.runtime.emit('HANDPY_VIRTUAL', {
                            type: `showAlertWithAixiong`,
                            data: {
                                maxDisplaySecs: 300,
                                closeButton: true,
                                content: '城市名称输入错误',
                                iconURL: miniIconURI
                                // iconSpinner: true
                            }
                        });
                        reject('城市名称输入错误')
                    } else {
                        this.runtime.emit('HANDPY_VIRTUAL', {
                            type: `showAlertWithAixiong`,
                            data: {
                                maxDisplaySecs: 3,
                                closeButton: true,
                                content: '请求失败',
                                iconURL: miniIconURI
                                // iconSpinner: true
                            }
                        });
                        reject('请求失败')
                    }
                }
                // {
                //     "results": [
                //       {
                //         "location": {
                //           "id": "C23NB62W20TF",
                //           "name": "西雅图",
                //           "country": "US",
                //           "path": "西雅图,华盛顿州,美国",
                //           "timezone": "America/Los_Angeles",
                //           "timezone_offset": "-07:00"
                //         },
                //         "now": {
                //           "text": "多云", //天气现象文字
                //           "code": "4", //天气现象代码
                //           "temperature": "14", //温度，单位为c摄氏度或f华氏度
                //           "feels_like": "14", //体感温度，单位为c摄氏度或f华氏度
                //           "pressure": "1018", //气压，单位为mb百帕或in英寸
                //           "humidity": "76", //相对湿度，0~100，单位为百分比
                //           "visibility": "16.09", //能见度，单位为km公里或mi英里
                //           "wind_direction": "西北", //风向文字
                //           "wind_direction_degree": "340", //风向角度，范围0~360，0为正北，90为正东，180为正南，270为正西
                //           "wind_speed": "8.05", //风速，单位为km/h公里每小时或mph英里每小时
                //           "wind_scale": "2", //风力等级，请参考：http://baike.baidu.com/view/465076.htm
                //           "clouds": "90", //云量，单位%，范围0~100，天空被云覆盖的百分比 #目前不支持中国城市#
                //           "dew_point": "-12" //露点温度，请参考：http://baike.baidu.com/view/118348.htm #目前不支持中国城市#
                //         },
                //         "last_update": "2015-09-25T22:45:00-07:00" //数据更新时间（该城市的本地时间）
                //       }
                //     ]
                //   }



                // if (ret.result && ret.result.user_list) {
                //     let res = ret.result.user_list[0];
                //     if (res.score > arg.reliability) {
                //         this.searchResultNames = res.user_id;
                //         this.searchScore = res.score
                //     }
                // }

                // resolve(ret.error_msg);

                // const words = [];
                // this.runtime.targets.forEach(target => {
                //     target.blocks._scripts.forEach(id => {
                //         const BaiduAI_hear = target.blocks.getBlock(id);
                //         if (BaiduAI_hear.opcode === 'BaiduBrain_BaiduAI_face_search') {
                //             // Grab the text from the hat block's shadow.
                //             const inputId = BaiduAI_hear.inputs.searchName.block;
                //             const inputBlock = target.blocks.getBlock(inputId);
                //             // Only grab the value from text blocks. This means we'll
                //             // miss some. e.g. values in variables or other reporters.
                //             if (inputBlock.opcode === 'text') {
                //                 const word = target.blocks.getBlock(inputId).fields.TEXT.value;
                //                 if (this.searchResultNames.indexOf(word) > -1) {
                //                     this.runtime.startHats('BaiduBrain_BaiduAI_face_search', { TEXT: word });
                //                     words.push(word);
                //                 }
                //             }
                //         }
                //     });
                // });
                // resolve();
                // this.runtime.startHats('BaiduBrain_searchDone', {});
            });
        });
    }
    seniverse_daily (args, utils) {

        if (this.wifi.status == '未连接') {
            return '没有连接wifi'
        }
        // this.wifi.status = '未连接'

        let {APIKEY, LOCATION, CLASSIFY} = args
        let classifyMap = {
            白天天气: 'text_day',
            最高温度: 'high',
            晚间天气: 'text_night',
            最低温度: 'low',
        }

        if (this.seniversePreData.lastresult_search == LOCATION && (new Date().getTime()) < (this.seniversePreData.lastresultDate + (30 * 60 * 1000))) {
            if (this.seniversePreData.daily) {
                if (this.seniversePreData.daily[classifyMap[CLASSIFY]] !== '') {
                    return this.seniversePreData.daily[classifyMap[CLASSIFY]]
                }
            }
        }
        // localStorage.getItem(keyword)
        // localStorage.setItem(keyword, `${value}`)

        const url = `https://api.seniverse.com/v3/weather/daily.json?key=${APIKEY}&location=${LOCATION}&start=0&days=1`;

        let resJson = {
        }
        return new Promise((resolve, reject) => {
            fetch(url, {
                method: 'GET',
                headers: {
                    // 'content-type': 'application/json'
                },
                // body: JSON.stringify(resJson)

            }).then(res => res.json()).then(ret => {
                console.log(ret)
                if (ret.results && ret.results[0]) {
                    this.seniversePreData = {
                        lastresult_search: LOCATION,
                        lastresult: ret.results[0],
                        lastresultDate: new Date().getTime(),
                        location: ret.results[0].location,
                        daily: ret.results[0].daily[0]
                    }
                    resolve(ret.results[0].daily[0][classifyMap[CLASSIFY]]);
                } else {
                    this.seniversePreData = {
                        lastresult_search: LOCATION,
                        lastresult: '',
                        lastresultDate: new Date().getTime(),
                        location: '',
                        daily: {
                            text_day: '',
                            high: '',
                            text_night: '',
                            low: ''
                        }
                    }
                    if (ret.status == 'The location can not be found.') {
                        this.runtime.emit('HANDPY_VIRTUAL', {
                            type: `showAlertWithAixiong`,
                            data: {
                                maxDisplaySecs: 3,
                                closeButton: true,
                                content: '城市名称输入错误',
                                iconURL: miniIconURI
                                // iconSpinner: true
                            }
                        });
                        reject('城市名称输入错误')
                    } else {
                        this.runtime.emit('HANDPY_VIRTUAL', {
                            type: `showAlertWithAixiong`,
                            data: {
                                maxDisplaySecs: 3,
                                closeButton: true,
                                content: '请求失败',
                                iconURL: miniIconURI
                                // iconSpinner: true
                            }
                        });
                        reject('请求失败')
                    }
                }
            });
        });
    }
    // "text_day": "多云",                //白天天气现象文字
    // "code_day": "4",                  //白天天气现象代码
    // "text_night": "晴",               //晚间天气现象文字
    // "code_night": "0",                //晚间天气现象代码
    // "high": "26",                     //当天最高温度
    // "low": "17",                      //当天最低温度

    // connection
    openHandpyModal (args) {
        this.handpyModal = true
        this.runtime.emit('HANDPY_VIRTUAL', {type: 'openHandpyModal', args});
    }
    closeHandpyModal (args) {
        this.handpyModal = false
        this.runtime.emit('HANDPY_VIRTUAL', {type: 'closeHandpyModal', args});
    }

    openHandpyWebsiteModal (args) {
        this.handpyWebsiteModal = true
        this.runtime.emit('HANDPY_VIRTUAL', {type: 'openHandpyWebsiteModal', args});
    }
    closeHandpyWebsiteModal (args) {
        this.handpyWebsiteModal = false
        this.runtime.emit('HANDPY_VIRTUAL', {type: 'closeHandpyWebsiteModal', args});
    }

    openHandpyMobileBtn (args) {
        this.handpyMobileBtn = true
        this.runtime.emit('HANDPY_VIRTUAL', {type: 'openHandpyMobileBtnModal', args});
    }
    closeHandpyMobileBtn (args) {
        this.handpyMobileBtn = false
        this.runtime.emit('HANDPY_VIRTUAL', {type: 'closeHandpyMobileBtnModal', args});
    }
    openHandpyMobileMsg (args) {
        this.handpyMobileMsg = true
        this.runtime.emit('HANDPY_VIRTUAL', {type: 'openHandpyMobileMsgModal', args});
    }
    closeHandpyMobileMsg (args) {
        this.handpyMobileMsg = false
        this.runtime.emit('HANDPY_VIRTUAL', {type: 'closeHandpyMobileMsgModal', args});
    }


}

module.exports = aixiongBlocks;
